<template>
    <div style="overflow-x: scroll;">
      <b-table
        :no-border-collapse="false"
        striped
        hover
        bordered
        responsive="sm"
        :perPage="perPage"
        :currentPage="currentPage"
        :items="items"
        :busy="false"
        :fields="fieldsTabela"
        class="mb-0 table-prazo"
        head-variant="light"
        small
      >
        <template v-slot:table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
  
        <!--HEADERS -->
  
        <!-- Início Prazos -->
        <!-- <template #head(selecao)> -->
        <template slot="HEAD_selecao">
          <div class="celula-selecao">
            <b-form-checkbox
              id="chk-selecionar-todos"
              title="Selecionar todos"
              v-model="todosSelecionados"
              name="chk-selecionar-todos"
              :value="true"
              :unchecked-value="false"
              @input="selecionarTudo()"
            />
          </div>
        </template>
  
        <template slot="HEAD_cnj">
          <div class="celula-cnj">
            <span>CNJ</span>
            <i class="filter coluna-fixa" :class="!isEmpty(filtros.cnj) || !isEmpty(filtros.tribunal)? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CNJ', 'mascara', '', '#######-##.####.#.##.####', $event)"></i>
          </div>
        </template>
  
        <template slot="HEAD_tipoPrazo">
          <div class="mw-60">
            <span>Tipo</span>
            <i class="filter" :class="!isEmpty(filtros.tipoPrazo) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo Prazo', 'checkbox', ['CIT', 'INT', 'AUD', 'ADM'], null, $event)"></i>
          </div>
        </template>
  
        <template slot="HEAD_statusPrazo">
          <div class="mw-120">
            <span>Status Prazo</span>
            <i class="filter" :class="!isEmpty(filtros.statusPrazo) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Status Prazo', 'checkbox', ['Aguardando Leitura', 'Aberto', 'Cumprido'], null, $event)"></i>
          </div>
        </template>
  
        <template slot="HEAD_dataHoraDisponibilizacao">
          <div class="mw-100">
            <span>Data Envio</span>
            <i class="filter" :class="!isEmpty(filtros.dataEnvio) || !isEmpty(filtros.tipoFiltroDataEnvio)? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data de Envio', 'data', '', null, $event)"></i>
          </div>
        </template>
  
        <template slot="HEAD_dias">
          <div class="mw-100">
            <span>Dias Prazo</span>
            <i class="filter" :class="!isEmpty(filtros.diasPrazo) || !isEmpty(filtros.tipoFiltroDiasPrazo) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Dias Prazo', 'numeroInteiro', '', null, $event)"></i>
          </div>
        </template>
  
        <template slot="HEAD_dataLeitura">
          <div class="mw-120">
            <span>Data Leitura</span>
            <i class="filter" :class="!isEmpty(filtros.dataAbertura) || !isEmpty(filtros.tipoFiltroDataAbertura) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Leitura', 'data', '', null, $event)"></i>
          </div>
        </template>
  
        <template slot="HEAD_dataVenc">
          <div class="mw-100">
            <span>Data Venc.</span>
            <i class="filter" :class="!isEmpty(filtros.dataVenc) || !isEmpty(filtros.tipoFiltroDataVenc) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Venc.', 'data', '', null, $event)"></i>
          </div>
        </template>
  
        <template slot="HEAD_meuVenc">
          <div class="mw-100">
            <span>Meu Venc.</span>
            <i class="filter" :class="!isEmpty(filtros.meuVenc) || !isEmpty(filtros.tipoFiltroMeuVenc) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Meu Venc.', 'data', '', null, $event)"></i>
          </div>
        </template>
  
        <template slot="HEAD_teorComunicacao">
          <div>
            <span>Teor da Comunicação</span>
            <i class="filter" :class="!isEmpty(filtros.teorComunicacao) || !isEmpty(filtros.tipoFiltroTeorComunicacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Teor da Comunicação', 'texto', '', null, $event)"></i>
          </div>
        </template>

        <!-- Fim Prazos -->
        <!-- Início Processo -->

        <template slot="HEAD_classeProcessual">
          <div class="mw-120">
            <span>Classe Processual</span>
            <i class="filter" :class="!isEmpty(filtros.classeProcessual) || !isEmpty(filtros.tipoFiltroClasseProcessual) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Classe Processual', 'texto', '', null, $event)"></i>
          </div>
        </template>

        <template slot="HEAD_dataAju">
          <div class="mw-100">
            <span>Data Aju.</span>
            <i class="filter" :class="!isEmpty(filtros.dataAju) || !isEmpty(filtros.tipoFiltroDataAju) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Aju.', 'data', '', null, $event)"></i>
          </div>
        </template>

        <template slot="HEAD_status">
          <div class="mw-60">
            <span>Status</span>
            <i class="filter" :class="!isEmpty(filtros.statusGrau) || !isEmpty(filtros.tipoFiltroStatusGrau) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Status Grau', 'texto', '', null, $event)"></i>
          </div>
        </template>

        <template slot="HEAD_devedor">
          <div class="mw-120">
            <span>Devedor</span>
            <i class="filter" :class="!isEmpty(filtros.devedor) || !isEmpty(filtros.tipoFiltroDevedor) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Devedor', 'texto', '', null, $event)"></i>
          </div>
        </template>

        <!-- Fim Processo -->
        <!-- Início Minuta -->

        <template slot="HEAD_minuta">
        <div class="mw-100">
            <span>Minuta</span>
            <i class="filter" :class="!isEmpty(filtros.minuta) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Minuta', 'radio', ['Sim', 'Não'], null, $event)"></i>
          </div>
        </template>

        <template slot="HEAD_modeloUtilizado">
          <div class="mw-120">
            <span>Modelo Utilizado</span>
            <i class="filter" :class="!isEmpty(filtros.modelo) || !isEmpty(filtros.tipoFiltroModelo) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Modelo Utilizado', 'texto', '', null, $event)"></i>
          </div>
        </template>

        <template slot="HEAD_relacaoCdas">
          <div class="mw-100">
            <span>Rel. CDAs</span>
            <i class="filter" :class="!isEmpty(filtros.relCdas) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Rel. CDAs', 'checkbox', ['Todos', 'Só Princ.', 'Não Gerar'], null, $event)"></i>
          </div>
        </template>

        <template slot="HEAD_anexos">
	      <div class="mw-100">
            <span>Anexos</span>
	        <i class="filter" :class="!isEmpty(filtros.anexos) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Anexos', 'radio', ['Sim', 'Não'], null, $event)"></i>
          </div>
        </template>

        <template slot="HEAD_statusMinuta">
	      <div class="mw-120">
            <span>Status da Minuta</span>
            <i class="filter" :class="!isEmpty(filtros.statusMinuta) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Status da Minuta', 'checkbox', ['Em Edição', 'Não Gerada', 'Gerada', 'Enviada'], null, $event)"></i>
          </div>
        </template>
        
        <template slot="HEAD_idAviso">
	      <div class="mw-60">
            <span>ID Aviso</span>
            <i class="filter" :class="!isEmpty(filtros.idAviso) || !isEmpty(filtros.tipoIdAviso) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('ID Aviso', 'texto', '', null, $event)"></i>
          </div>
        </template>
        <!-- Fim Minuta -->
  
        <!-- /HEADERS -->
  
        <!-- CELULAS -->
  
        <template slot="selecao" slot-scope="row">
          <b-form-checkbox
            v-model="row.item.selecao"
            name="checkbox-1"
            :unchecked-value="false"
            :value="true"
            @change.native="selecionar(row.item)"
            :disabled="row.item.erro || ('minuta' === perfil && row.item.enviada)"
          >
          </b-form-checkbox>
        </template>
  
        <template slot="cnj" slot-scope="row">
          <div :class="negritoIfNovo(row.item)">
            <span>
              {{ formatarCNJ(row.item.cnj) }} ({{ getTribunalEnum(row.item.indTribunal) }})
            </span>
          <div class="float-right">
            <b-button
              variant="link"
              class="p-0" size="sm"
              :style="{color: getCorAnotacao(row.item)}"
              v-b-modal.modal-anotacao-processo
              title="Anotações do Processo"
              @click="iniciarModalAnotacao(row.item)"
            >
              <!-- <span class="icon-blue fa-15x"><svg-icon-comentarios></svg-icon-comentarios></span> -->
              <i class="iconeTransparente fa fa-comments-o fa-15x"></i>
            </b-button>
            <b-button
              variant="link"
              class="p-0" size="sm"
              :style="{color: getCorProcessoImportante(row.item)}"
              v-b-modal.modal-processo-importante
              title="Processo Importante"
              @click="iniciarModalProcessoImportante(row.item)"
            >
              <!-- <span class="icon-blue fa-15x"><svg-icon-favorito></svg-icon-favorito></span> -->
              <i class="iconeTransparente fa fa-star-o fa-15x"></i>
            </b-button>
            <b-button
              variant="link"
              class="p-0" size="sm"
              style="color: #BEBEBE"
              title="Copiar CNJ"
              @click="copiarCNJ(row.item.cnj)"
            >
              <i class="iconeTransparente fa fa-copy fa-15x"></i>
            </b-button>
          </div></div>
        </template>

        <template slot="tipoPrazo" slot-scope="row">
          <div :class="negritoIfNovo(row.item)">
            {{ row.item.tipoPrazo }}
          </div>
        </template>

        <template slot="statusPrazo" slot-scope="row">
          <div :class="negritoIfNovo(row.item)">
            {{ getStatusPrazoEnum(row.item.statusPrazo) }}
          </div>
        </template>

        <template slot="dataHoraDisponibilizacao" slot-scope="row">
          <div :class="negritoIfNovo(row.item)">
            {{ formatarData(row.item.dataHoraDisponibilizacao) }}
          </div>
        </template>

        <template slot="dias" slot-scope="row">
          <div :class="negritoIfNovo(row.item)">
            {{ row.item.dias }}
          </div>
        </template>

        <template slot="dataLeitura" slot-scope="row">
          <div :class="negritoIfNovo(row.item)">
            {{ formatarData(row.item.dataLeitura) }}
          </div>
        </template>

        <template slot="dataVenc" slot-scope="row">
          <div :class="negritoIfNovo(row.item)">
            {{ formatarData(row.item.dataVenc) }}
          </div>
        </template>

        <template slot="meuVenc" slot-scope="row">
          <div :class="negritoIfNovo(row.item)">
            {{ formatarData(row.item.meuVenc) }}
          </div>
        </template>

        <template slot="teorComunicacao" slot-scope="row">
          <div :class="negritoIfNovo(row.item)">
            {{ row.item.teorComunicacao }}
          </div>
        </template>

        <template slot="classeProcessual" slot-scope="row">
          <div :class="negritoIfNovo(row.item)">
            {{ row.item.classeProcessual }}
          </div>
        </template>

        <template slot="dataAju" slot-scope="row">
          <div :class="negritoIfNovo(row.item) + classDataAju(row.item.dataAju)">
            {{ formatarData(row.item.dataAju) }} 
            {{ calcularDiferencaAnosEMeses(row.item.dataAju) }}
          </div>
        </template>

        <template slot="status" slot-scope="row">
          <div :class="negritoIfNovo(row.item)">
            {{ row.item.status }}
          </div>
        </template>

        <template slot="devedor" slot-scope="row">
          <div :class="negritoIfNovo(row.item)">
            {{ row.item.devedor }}
          </div>
        </template>

	      <template slot="minuta" slot-scope="row">
		      <b-button
			      variant="link"
			      class="p-1 icone-3"
			      title="Editar Minuta"
			      :disabled="!row.item.minuta"
			      @click="iniciarModalMinuta(row.item)"
		      ><i class="iconeTransparente fa fa-file-text-o fa-15x"></i
		      ></b-button>
	      </template>

	      <template slot="modeloUtilizado" slot-scope="row">
		      <div>
			      {{ row.item.modeloUtilizado }}
		      </div>
	      </template>

        <template slot="relacaoCdas" slot-scope="row">
	      <b-form-select
		      v-model="row.item.relCDAs"
		      plain
		      class="mini-select"
		      :disabled="!row.item.relCDAs || row.item.enviada"
		      :class="classeRelCDAs(row.item.relCDAs)"
		      @change="alterarRelCda(row.item.codPeticionamento, row.item.relCDAs)"
	      >
		      <option
			      v-for="tc in relCdaOpcoes"
			      :key="tc.value"
			      :value="tc.value">
			      {{ tc.text }}
		      </option>
	      </b-form-select>
        </template>

	      <template slot="anexos" slot-scope="row">
		      <b-button
			      variant="link"
			      class="p-1 icone-3"
			      title="Anexos da Petição"
			      :disabled="!row.item.minuta"
			      :class="row.item.peticionamentoDocumentos && row.item.peticionamentoDocumentos.length > 0 ? '' : 'btn-link-vazio'"
			      @click="iniciarModalAnexos(row.item)"
		      ><i class="iconeTransparente fa fa-paperclip fa-15x"></i
		      ></b-button>
	      </template>

	      <template slot="statusMinuta" slot-scope="row">
		      <div>
			      {{ row.item.statusMinuta }}
		      </div>
	      </template>

      </b-table>
      <b-row class="center-xy mt-3">
        <b-col md="12">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            size="md"
            align="center"
          ></b-pagination>
        </b-col>
      </b-row>
  
      <!-- Modal Sincronizar Projudi -->
  
      <b-modal
        id="modal-recarregar"
        size="md"
        ref="modalRecarregar"
        scrollable
        centered
        header-bg-variant="primary"
        header-text-variant="white"
        footer-class="d-flex justify-content-center align-items-center"
        @shown="onOpenModalSincronizar"
      >
        <template #modal-header="{ close }">
          <H5>Sincronização com o PROJUDI - Obter Prazos</H5>
          <button
            class="close text-white ml-1"
            @click="close()"
            aria-label="close"
            :disabled="sincronizando"
          >
            &times;
          </button>
        </template>

        <div v-if="statusSincronizacao.inicio == undefined">
          <p>
            Confirma a sincronização com o Projudi?
          </p>
          <p>
            <small>
              (última sincronização: {{dataHoraUltimaAtualizacao}})
            </small>
          </p>
        </div>
        <div v-else>
          <p v-if="exibeIniciando(statusSincronizacao.solicitacao1Grau)">
            Iniciando solicitação MNI 1º Grau.
          </p>
          <p v-if="exibeEnviada(statusSincronizacao.solicitacao1Grau)">
            Solicitação enviada com sucesso.
          </p>
          <div v-if="exibeEmProcessamento(statusSincronizacao.solicitacao1Grau)">
            <p>
              Resposta recebida em processamento.
            </p>
            <p>
              <b>
                {{statusSincronizacao.qtdProcessado1Grau}} prazo(s) processado(s) do 1º Grau
              </b>
            </p>
            <p>
              Atualizando a sua Agenda de Prazos. Aguarde...
            </p>
          </div>

          <p v-if="exibeIniciando(statusSincronizacao.solicitacao2Grau)">
            Iniciando solicitação MNI 2º Grau.
          </p>
          <p v-if="exibeEnviada(statusSincronizacao.solicitacao2Grau)">
            Solicitação enviada com sucesso.
          </p>
          <div v-if="exibeEmProcessamento(statusSincronizacao.solicitacao2Grau)">
            <p>
              Resposta recebida em processamento.
            </p>
            <p>
              <b>
                {{statusSincronizacao.qtdProcessado2Grau}} prazo(s) processado(s) do 2º Grau
              </b>
            </p>
          </div>
          <p v-if="exibeAtualizando(statusSincronizacao.solicitacao2Grau)">
            Atualizando a sua Agenda de Prazos. Aguarde...
          </p>
          <p v-if="statusSincronizacao.fim != null">
            <b v-if="statusSincronizacao.erros == null || statusSincronizacao.erros.length == 0">
              Agenda de Prazos atualizada com sucesso!
            </b>
            <b v-else>
              Não foi possível realizar a sincronização! Aguarde alguns minutos e tente novamente. Se o problema persistir, entre em contato com a DASTI.
            </b>
          </p>
        </div>
  
        <template v-slot:modal-footer="{ cancel }" v-if="statusSincronizacao.inicio != undefined">
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            :disabled="sincronizando"
            @click.prevent="listarAgendaPrazos();cancel()"
          >
            <i class="fa fa-reply"></i> Fechar
          </b-button>
        </template>
        <template v-slot:modal-footer="{ cancel }" v-else>
          <b-button
            class="fonte-branca ml-1"
            variant="secondary"
            @click.prevent="cancel()"
          >
            <i class="fa fa-reply"></i> Cancelar
          </b-button>
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="sincronizar()"
          >
            <i class="fa fa-check"></i> Confirmar a sincronização
          </b-button>
        </template>
      </b-modal>

      <!-- Modal Abrir Prazo -->
	    <b-modal
		    id="modal-abrir-prazo"
		    size="md"
		    ref="modalAbrirPrazo"
		    scrollable centered
		    header-bg-variant="danger"
		    header-text-variant="white"
		    title="Confirmar a Abertura de Prazos"
		    footer-class="d-flex justify-content-center align-items-center"
        @shown="onOpenModalAbrirPrazo"
	    >
        <template #modal-header="{ close }">
          <H5>Confirmar a Abertura de Prazos</H5>
          <button
            class="close text-white ml-1"
            @click="close()"
            aria-label="close"
            :disabled="statusProcessamento == 'START'"
          >
            &times;
          </button>
        </template>
		    <p>
			    Confirma a abertura dos prazos abaixo? (essa operação é irreversível)
		    </p>

		    <p v-for="sel in selecionados" :key="sel.codPrazoProcurador">
			    - {{ formatarCNJ(sel.cnj) }}
		    </p>
        <p class="text-center">
          <small v-if="statusProcessamento == 'START'">
            Processando...
          </small>
          <small v-else-if="statusProcessamento == 'END'">
            Abertura Concluída!
          </small>
          <small v-else-if="statusProcessamento == 'ERRO'">
            Não foi possível realizar a abertura. Ressincronize a sua agenda de prazos!
          </small>
        </p>

		    <template v-slot:modal-footer="{ cancel }">
			    <b-button
				    class="fonte-branca ml-1"
				    variant="secondary"
				    @click.prevent="cancel()"
            v-if="statusProcessamento == null || statusProcessamento == 'START'"
            :disabled="statusProcessamento == 'START'"
			    >
				    <i class="fa fa-reply"></i> Cancelar
			    </b-button>
			    <b-button
				    class="fonte-branca ml-1"
				    variant="danger"
				    @click.prevent="abrirPrazos();"
            v-if="statusProcessamento == null || statusProcessamento == 'START'"
            :disabled="statusProcessamento == 'START'"
			    >
				    <i class="fa fa-save"></i> Confirmar a abertura
			    </b-button>
			    <b-button
				    class="fonte-branca ml-1"
				    variant="danger"
				    @click.prevent="listarAgendaPrazos();cancel()"
            v-if="statusProcessamento == 'END' || statusProcessamento == 'ERRO'"
			    >
				    <i class="fa fa-reply"></i> Fechar
			    </b-button>
		    </template>
	    </b-modal>  
      <!-- Modal Calcular prazos -->

      <b-modal
        id="modal-calcular-prazo" size="md" ref="modalCalcularPrazo"
        scrollable centered
        header-bg-variant="primary"
        header-text-variant="white"
        title="Cálculo de vencimento dos Prazos Fechados"
        footer-class="d-flex justify-content-center align-items-center"
      >
        <p>
          Para os prazos no status "Aguardando Leitura" e sem vencimento, digite abaixo um prazo para o cálculo
        </p>      
  
        <b-row>
          <b-col sm="12" md="6">
            <b-form-group
              label="Digite o Prazo (dias):"
              label-for="prazo"
              class="text-label"
            >
              <b-form-input
                required
                type="number"
                id="prazo"
                maxlength="8"
                min=0
                v-model="qtdDiasCalcularPrazo"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            class="fonte-branca ml-1"
            variant="secondary"
            @click.prevent="cancel();qtdDiasCalcularPrazo = null;"
          >
            <i class="fa fa-times"></i> Cancelar
          </b-button>
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            :disabled="!(qtdDiasCalcularPrazo > 0)"
            @click.prevent="calcularPrazos();cancel()"
          >
            <i class="fa fa-calculator"></i> Calcular
          </b-button>
        </template>
      </b-modal>
  
      <!-- Modal CDAs do processo 0000548-36.2005.8.16.0064 -->
      <b-modal
        id="modal-cda"
        size="lg"
        ref="modalTabelionato"
        scrollable
        centered
        header-bg-variant="primary"
        header-text-variant="white"
        title="CDAs do processo 0000548-36.2005.8.16.0064"
        footer-class="d-flex justify-content-center align-items-center"
      >
        <b-row>
          <b-col xs="12" sm="12" md="12" lg="12" xl="12">
            <!-- TODO campo estava com erro no log
            <b-form-group
              label="Tipo de Carta"
              label-for="radio-group-tipo-carta"
            >
              <b-form-radio-group
                id="radio-group-tipo-carta"
                v-model="tipoCarta"
                name="radio-tipo-carta"
              >
                <b-form-radio value="0">Do processo e seus apensos</b-form-radio>
                <b-form-radio value="1">Apenas do processo</b-form-radio>
              </b-form-radio-group>
            </b-form-group> -->
          </b-col>
        </b-row>
        <hr />
        <!-- <b-table striped hover :items="itemsCda" :fields="fieldsCda"></b-table> TODO campo com erro no log -->
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="cancel()"
          >
            <i class="fa fa-reply"></i> Voltar
          </b-button>
        </template>
      </b-modal>
  
  
      <!-- Modal Tabela de Vencimentos -->
  
      <b-modal
        id="modal-tabela-vencimentos" size="md" ref="modalTabelaVencimentos"
        @shown="onOpenModalTabelaVencimentos"
        scrollable centered
        header-bg-variant="primary"
        header-text-variant="white"
        title="Tabela de Vencimento dos Prazos"
        footer-class="d-flex justify-content-center align-items-center"
      >

        <b-table
          striped hover bordered responsive
          :items="itemsVencimento"
          :busy="false"
          :fields="tbFieldsVencimentos"
          class="mb-0 table-prazo"
          head-variant="light"
          small
        >
          <template slot="dataVencimento" slot-scope="row">
            {{ row.item.isData ? formatarData(row.item.dataVencimento) : row.item.texto }}
          </template>
        </b-table>
  
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="cancel();itemsVencimento = [];"
          >
            <i class="fa fa-reply"></i> Voltar
          </b-button>
        </template>
      </b-modal>
  
      <!-- Modal Vencimento Manual -->
  
      <b-modal
        id="modal-vencimento-manual"
        size="md"
        ref="modalVencimentoManual"
        scrollable
        centered
        header-bg-variant="primary"
        title="Anotar vencimento manual"
        footer-class="d-flex justify-content-center align-items-center"
      >
        <p>
          Anote um vencimento manual para os prazos selecionados na grid:
        </p>
        <p v-for="sel in selecionados" :key="sel.codPrazoProcurador">
          - {{ formatarCNJ(sel.cnj) }}
        </p>
  
        <b-row>
          <b-col sm="12" md="6">
            <label for="dataVencimentoManual">
              Data de Vencimento:
              <span class="text-danger"></span>
            </label>
            <b-input id="dataVencimentoManual" type="date" placeholder v-model="dataVencimentoManual"></b-input>
          </b-col>
        </b-row>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            class="fonte-branca ml-1"
            variant="secondary"
            @click.prevent="cancel();dataVencimentoManual=null;"
          >
            <i class="fa fa-times"></i> Cancelar
          </b-button>
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            :disabled="!dataVencimentoManual"
            @click.prevent="anotarVencimentoManual();cancel();"
          >
            <i class="fa fa-calendar"></i> Anotar
          </b-button>
        </template>
      </b-modal>
      <!-- Modal Confirmar a Abertura dos Prazos -->
  
  
  
      <!-- Modal Ver Movimento -->
  
      <b-modal
        id="modal-ver-movimento" size="xl" ref="modalVerMovimento"
        scrollable centered 
        header-bg-variant="primary"
        header-text-variant="white"
        header-class="header-modal-ver-movimento"
        footer-class="d-flex justify-content-center align-items-center"
        @shown="onOpenModalVerMovimentos"
      >
      <template #modal-header="{ close }">
        <div class="d-flex flex-column" style="width: 100%;">
          <div class="pl-3 pr-3 pb-3 d-flex flex-row">
            <h5 class="modal-title">
              Movimentos Relevantes do processo n. {{ processoSelecionado ? formatarCNJ(processoSelecionado.cnj) : '' }}
            </h5>
            <b-button variant="cda" @click="imprimirMovimentosProcesso" class="py-0 ml-auto">
              <i class="fa fa-file-pdf-o"></i> Imprimir
            </b-button>
            <button
              class="close text-white ml-1"
              @click="close()"
              aria-label="close"
            >
              &times;
            </button>
          </div>

          <div class="py-2" style="float: right; text-align: end; background: white;">
            <b-button variant="cda" @click="sincronizarMovimentos" class="py-0 ml-auto">
              <i class="fa fa-refresh"></i> Sincronizar
            </b-button>
            <span class="text-dark pr-3">
              Última sincronização: {{ (processoSelecionado && processoSelecionado.dataHoraConsultaMovimento) ? formatarDataHora(processoSelecionado.dataHoraConsultaMovimento) : '-' }}
            </span>
          </div>
        </div>
        </template>

        <p v-for="mp in movimentosProcesso" :key="mp.identificador">
          <b>Mov. {{ mp.identificador }} -</b> <span v-html="estilizaPalavraChave(mp.complementoTribunal)"></span>
        </p>
  
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            class="fonte-branca ml-1"
            variant="primary "
            @click.prevent="cancel()"
          >
            <i class="fa fa-reply"></i> Voltar
          </b-button>
        </template>
      </b-modal>
  
      <!-- Modal PDF vinculado ao prazo do processo n. 0003599-16.2024.8.16.0185 -->
      <b-modal
        id="modal-vinculado"
        size="lg"
        ref="modalVinculado"
        scrollable
        centered
        header-bg-variant="primary"
        header-text-variant="white"
        :title="'PDF vinculado ao prazo do processo n. ' + (processoSelecionado ? formatarCNJ(processoSelecionado.cnj) : '')"
        footer-class="d-flex justify-content-center align-items-center"
        @shown="onOpenModalVerPdf"
      >
        <div>
          <template v-if="isLoadingPdf">
            Carregando...
          </template>
          <div class="d-flex justify-content-center align-items-center pb-3">
            <b-button v-if="!isLoadingPdf && pdf" variant="cda" @click="imprimirVerPdf" class="py-1 ml-auto ">
              <i class="fa fa-file-pdf-o"></i> Imprimir
            </b-button>
          </div>
          
          <vue-pdf-embed v-if="!isLoadingPdf && pdf" :source="pdf" width="750" ref="pdfEmbededRef" />
          <template v-else-if="!isLoadingPdf">
            A intimação não possui PDF atrelado.
          </template>
        </div>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="cancel()"
          >
            <i class="fa fa-reply"></i> Voltar
          </b-button>
        </template>
      </b-modal>
      <!-- Modal Anotação Processo -->
  
      <b-modal
        id="modal-anotacao-processo"
        size="xl"
        ref="modalComentarios"
        scrollable
        centered
        header-bg-variant="primary"
        header-text-variant="white"
        
        footer-class="d-flex justify-content-center align-items-center"
      >
        <template #modal-header="{ close }">
          <h5 class="modal-title">Comentários do processo {{formatarCNJ(anotacaoProcesso.numeroUnico)}}</h5>
          <b-button variant="cda" @click="imprimirAnotacaoProcesso" class="py-0 ml-auto">
            <i class="fa fa-file-pdf-o"></i> Imprimir
          </b-button>
          <button
            class="close text-white ml-1"
            @click="close()"
            aria-label="close"
          >
            &times;
          </button>
        </template>
     
  
        <b-row>
          <b-col xs="12" sm="12" md="12" lg="12" xl="12">
            <b-form-textarea
              id="textarea"
              v-model="anotacaoProcesso.anotacao"
              rows="12"
            ></b-form-textarea>
          </b-col>
        </b-row>
  
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            class="fonte-branca ml-1"
            variant="secondary"
            @click.prevent="cancel()"
          >
            <i class="fa fa-times"></i> Cancelar
          </b-button>
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="salvarAnotacao();cancel();"
          >
            <i class="fa fa-save"></i> Salvar
          </b-button>
        </template>
      </b-modal>
      <!-- Modal Processo Importante -->
  
      <b-modal
        id="modal-processo-importante"
        size="md"
        ref="modalProcessoImportante"
        scrollable
        centered
        header-bg-variant="primary"
        header-text-variant="white"
        :title="`Processo Importante ${formatarCNJ(processoImportante.numeroUnico)}`"
        footer-class="d-flex justify-content-center align-items-center"
      >
  
        <b-form-textarea
          id="textarea"
          v-model="processoImportante.anotacao"
          rows="12"
        ></b-form-textarea>
  
        <template v-slot:modal-footer="{ cancel }">
          <b-button
          class="fonte-branca ml-1"
          variant="secondary"
          @click.prevent="cancel()"
          >
          <i class="fa fa-times"></i> Cancelar
        </b-button>
        <b-button
          class="ml-1"
          variant="outline-danger"
          @click.prevent="excluirProcessoImportante();cancel();"
        >
          <i class="fa fa-times"></i> Excluir Importante
        </b-button>
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="salvarProcessoImportante();cancel();"
          >
            <i class="fa fa-save"></i> Salvar
          </b-button>
        </template>
      </b-modal>

      <!-- Modal Ver CDA -->
      <b-modal
        id="modal-ver-cda" ref="modalVerCdaRef" size="lg"
        scrollable centered
        header-bg-variant="primary"
        header-text-variant="white"
        footer-class="d-flex justify-content-center align-items-center"
        @shown="onOpenModalVerCDA"
      >
        <template #modal-header="{ close }" v-if="processoSelecionado">
          <h5 class="modal-title">CDAs do processo {{formatarCNJ(processoSelecionado.cnj)}}</h5>
          <b-button variant="cda" @click="imprimirCDAs" class="py-0 ml-auto">
            <i class="fa fa-file-pdf-o"></i> Imprimir
          </b-button>
          <button
            class="close text-white ml-1"
            @click="close()"
            aria-label="close"
          >
            &times;
          </button>
        </template>
        <template v-if="isLoadingCDA">
          Carregando...
        </template>
        <b-row>
          <b-col xs="8" sm="8" md="8" lg="8" xl="8">
            <b-form-radio-group
              id="radio-group-2"
              name="radio-sub-component"
              v-model="selecaoCdas"
              @input="onOpenModalVerCDA()"
            >
              <b-form-radio value="true">
                Do processo e seus apensos
              </b-form-radio>
              <b-form-radio value="false">Apenas do processo</b-form-radio>
            </b-form-radio-group>
          </b-col>
          <b-col xs="4" sm="4" md="4" lg="4" xl="4" class="text-right font-italic" v-if="dadosCDA">
            Consulta em: {{ formatarDataHora(dadosCDA.dataHoraConsulta) }}
          </b-col>
        </b-row>
        <div id="conteudoModalCDA">
          <b-row v-if="dadosCDA">
            <b-col xs="11" sm="11" md="11" lg="11" xl="11">
              <p></p>
              <p>
                <b class="text-danger">{{ dadosCDA.qtdProcessos }}</b> processo(s) contendo
                <b class="text-danger">{{ dadosCDA.cdas.length }}</b> CDA(s), novalor total de
                <b class="text-danger">{{ formatarMoeda(dadosCDA.valorTotal)}}</b>
              </p>
              <br />
            </b-col>
            <b-col xs="1" sm="1" md="1" lg="1" xl="1">
              <b-button variant="link" @click="copiarConteudoModalCDA" class="py-0 ml-auto">
                <i class="fa fa-copy"></i>
              </b-button>
              <textarea spellcheck="false" data-ms-editor="true" style="position: fixed; visibility: hidden;" id="textareaCopy">{{ dadosCDA.cdasString }}</textarea>
            </b-col>
          </b-row>

          <b-table v-if="dadosCDA" striped hover :items="dadosCDA.cdas" :fields="fieldscda">
            <template slot="cnj" slot-scope="row">
              {{ formatarCNJ(row.item.cnj) }}
            </template>

            <template slot="numeroCda" slot-scope="row">
              <b-link @click="abrirModalExtratoCda(row.item.numeroCda)" class="m-0 p-0 text-center">
                  <p class="m-0 p-0"> {{row.item.numeroCda}}</p>
              </b-link>
            </template>
            
            <template slot="valor" slot-scope="row">
              {{ formatarMoeda(row.item.valor) }}
            </template>
          </b-table>
          <ExtratoCda
              ref="extratoCda"
              @closeModal="closeModal" />
        </div>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="cancel()"
          >
            <i class="fa fa-reply"></i> Voltar
          </b-button>
        </template>
      </b-modal>

      <!--  Modal Dossiê do devedor -->
      <b-modal
        id="modal-ver-dossie" ref="modalVerDossieRef" size="xl"
        scrollable centered
        header-bg-variant="primary"
        header-text-variant="white"
        footer-class="d-flex justify-content-center align-items-center"
        @shown="onOpenModalVerDossie"
      >
        <template #modal-header="{ close }">
          <h5 class="modal-title">
            Dossiê do devedor {{ processoSelecionado ? processoSelecionado.devedor : '' }}
          </h5>
          <b-button variant="cda" @click="imprimirDossie" class="py-0 ml-auto">
            <i class="fa fa-file-pdf-o"></i> Imprimir
          </b-button>
          <button
            class="close text-white ml-1"
            @click="close()"
            aria-label="close"
          >
            &times;
          </button>
        </template>
        <template v-if="isLoadingDossie">
            Carregando...
          </template>
        <template v-if="dadosDossie">
          <b-row>
            <b-col xs="8">
              <p></p>
              <p><b class="text-danger">{{ dadosDossie.processos.length }}</b> Execuções fiscais encontradas</p>
              <br />
            </b-col>
            <b-col xs="3" class="text-right font-italic">
              Consulta em: {{ formatarDataHora(dadosDossie.dataHoraConsulta) }}
            </b-col>
            <b-col xs="1" sm="1" md="1" lg="1" xl="1">
              <b-button variant="link" @click="copiarConteudoModalDossie" class="py-0 ml-auto">
                <i class="fa fa-copy"></i>
              </b-button>
              <textarea spellcheck="false" data-ms-editor="true" style="position: fixed; visibility: hidden;" id="textareaCopyDossie">{{ dadosDossie.conteudoCopiar }}</textarea>
            </b-col>
          </b-row>

          <b-table-simple
            striped hoverhover small responsive
            class="mb-0 table-prazo"
            head-variant="light"
          >
            <b-tbody id="conteudoModalDossie">
              <b-tr v-for="(proc, procIdx) in dadosDossie.processos" :key="procIdx">
                <b-td class="text-left" style="width: 210px;">
                  {{ formatarCNJ(proc.cnj) }}
                  <b-button
                    variant="link"
                    class="p-0" size="md"
                    title="Copiar CNJ"
                    @click="copiarCNJDossie(proc.cnj)"
                  >
                    <i class="fa fa-files-o"></i>
                  </b-button>
                  <textarea spellcheck="false" data-ms-editor="true" style="position: fixed; visibility: hidden;" :id="'textareaCopyCnjDossie'+proc.cnj">{{ proc.cnj }}</textarea>
                </b-td>

                <td class="p-0 text-left">
                  <template v-for="mov in proc.movimentos">
                    <p>
                      <span style="font-weight: bold">Mov. {{ mov.identificador }}</span> - <span v-html="estilizaPalavraChave(mov.complementoTribunal)"></span>
                    </p>
                  </template>
                </td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </template>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="cancel()"
          >
            <i class="fa fa-reply"></i> Voltar
          </b-button>
        </template>
      </b-modal>

      <!--  Modal Consulta Trovale -->
      <b-modal
        id="modal-pesquisa-trovale"
        size="md"
        ref="modalPesquisaTrovale"
        centered
        header-bg-variant="primary"
        header-text-variant="white"
        :title="`Dados do devedor ${processoSelecionado && processoSelecionado.devedor ? processoSelecionado.devedor : ''}`"
        footer-class="d-flex justify-content-center align-items-center"
        @shown="onOpenModalPesquisaTrovale"
      >
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="exportarTrovaleCSV();"
          >
            <i class="fa fa-file-excel-o"></i> Exportar CSV
          </b-button>
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="exportarTrovalePDF();"
          >
            <i class="fa fa-file-pdf-o"></i> Exportar PDF
          </b-button>
          <b-button
            class="fonte-branca ml-1"
            variant="secondary"
            @click.prevent="cancel()"
          >
            <i class="fa fa-times"></i> Cancelar
          </b-button>
        </template>
      </b-modal>

		<!--Modal Consultar Modelos-->
	    <b-modal
		    id="modal-consultar-modelos"
		    ref="modalConsultarModelos"
		    size="lg"
		    scrollable
		    centered
		    header-bg-variant="primary"
		    header-text-variant="white"
		    title="Banco de Modelos"
		    footer-class="d-flex justify-content-center align-items-center"
		    @shown="onOpenModalPesquisaModelos"
	    >
		    <b-row class="mb-3">
			    <b-col sm="12" md="3">
				    <b-form-input
					    type="number"
					    v-model="filtroIdModelo"
					    maxlength="8"
					    placeholder="Filtrar por ID"
					    @change="filtrarModelos()"
				    />
			    </b-col>
			    <b-col sm="12" md="8">
				    <b-form-input
					    type="text"
					    maxlength="300"
					    v-model="filtroDescritivoModelo"
					    placeholder="Filtrar por Descritivo"
					    @change="filtrarModelos()"
				    />
			    </b-col>
			    <b-col sm="12" md="1">
				    <b-button variant="link" class="btn-link-vazio" style="padding: 0 !important;" @click="limparFiltroModelo()">
					    <i class="iconeTransparente fa fa-eraser fa-15x"></i>
				    </b-button>
			    </b-col>
		    </b-row>
		    <b-table
			    id="bloqueios"
			    ref="tableBloqueios"
			    :items="modelosPesquisa"
			    :fields="camposModelo"
			    :no-border-collapse="false"
			    striped
			    hover
			    bordered
			    responsive=""
			    :busy="false"
			    class="mb-0"
			    head-variant="light"
			    small
		    >
			    <template v-slot:table-busy>
				    <div class="text-center my-2">
					    <b-spinner class="align-middle"></b-spinner>
					    <strong>Carregando...</strong>
				    </div>
			    </template>

			    <template slot="HEAD_descricao">
				    <div class="d-flex justify-content-between align-items-center">
					    <span>Descritivo</span>
				    </div>
			    </template>

			    <template slot="selecao" slot-scope="row">
				    <b-form-radio
					    v-model="modeloSelecionado"
					    name="checkbox-1"
					    :unchecked-value="false"
					    :value="row.item"
					    :disabled="row.item.erro"
				    >
				    </b-form-radio>
			    </template>

			    <template slot="exibir" slot-scope="row">
				    <b-button variant="link"
				              @click="atribuirModelo(row.item);$bvModal.show('modal-modelo')">
					    <span class="icon-clip"><i class="fa fa-file-text-o"></i></span>
				    </b-button>
			    </template>
		    </b-table>

		    <template v-slot:modal-footer="{ cancel }">
			    <b-button
				    class="fonte-branca ml-1"
				    variant="secondary"
				    @click.prevent="cancel()"
			    >
				    <i class="fa fa-times"></i> Cancelar
			    </b-button>
			    <b-button
				    class="fonte-branca ml-1"
				    variant="primary"
				    @click="applicarModelo()"
				    :disabled="!modeloSelecionado || selecionados.length < 1"
			    >
				    <i class="fa fa-file-text"></i> Aplicar Modelo
			    </b-button>
		    </template>
	    </b-modal>

		<!--Modal Consultar Modelos-->
	    <b-modal id="modal-sucesso-modelos"
	             ref="modalSucessoModelos"
	             size="md"
	             title="Modelo Aplicado"
	             scrollable
	             centered
	             header-bg-variant="primary"
	             header-text-variant="white"
	             footer-class="d-flex justify-content-center align-items-center"
	             cancel-title="Fechar">

		    <p>Minuta gerada com sucesso para o(s) processo(s):</p>
		    <p v-for="sel in modelosApplicados">
			    - {{ formatarCNJ(sel) }}
		    </p>

		    <template v-slot:modal-footer="{ cancel }">
			    <b-button
				    class="fonte-branca ml-1"
				    variant="primary"
				    @click.prevent="cancel()"
			    >
				    <i class="fa fa-reply"></i> Fechar
			    </b-button>
		    </template>
	    </b-modal>

	    <b-modal id="modal-modelo"
	             size="lg"
	             title="Exibir Modelo"
	             header-bg-variant="primary"
	             header-text-variant="white"
	             cancel-title="Fechar">

		    <b-card v-if="modelo">
			    <b-row>
				    <b-col xs="12" sm="12" md="8" lg="8" xl="8">
					    <b-form-group label="Descrição:" label-for="descricao" class="text-label">
						    <b-form-input
							    id="descricao"
							    name="descricao"
							    v-model="modelo.descricao"
							    type="text"
							    :disabled="true" />
					    </b-form-group>
				    </b-col>
				    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
					    <b-form-group label="Movimento:" label-for="movimento" class="text-label">
						    <b-form-input
							    id="movimento"
							    name="movimento"
							    v-model="modelo.movimento"
							    type="text"
							    :disabled="true" />
					    </b-form-group>
				    </b-col>
			    </b-row>
			    <b-row>
				    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
					    <b-form-group label="Tipo de Tramitação:" label-for="tipoTramitacao" class="text-label">
						    <b-form-input
							    id="tipoTramitacao"
							    name="tipoTramitacao"
							    v-model="modelo.tipoTramitacao"
							    type="text"
							    :disabled="true" />
					    </b-form-group>
				    </b-col>
				    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
					    <b-form-group label="Tipo de Documento:" label-for="tipoDocumento" class="text-label">
						    <b-form-input
							    id="tipoDocumento"
							    name="tipoDocumento"
							    v-model="modelo.tipoDocumento"
							    type="text"
							    :disabled="true" />
					    </b-form-group>
				    </b-col>
			    </b-row>
			    <b-row>
				    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
					    <b-form-group
						    id="situacao"
						    label="Situação:"
						    label-for="situacao">
						    <b-form-checkbox :disabled="true" switch v-model="modelo.indAtivo">{{ modelo.indAtivo ? 'Ativo' : 'Inativo'}}</b-form-checkbox>
					    </b-form-group>
				    </b-col>
			    </b-row>
			    <b-row class="overflow-grid">
				    <b-col xs="12" sm="12">
					    <vue-editor id="editor" v-model="modelo.textoModelo" :disabled="true"></vue-editor>
				    </b-col>
			    </b-row>
		    </b-card>

		    <template v-slot:modal-footer="{ cancel }">
			    <b-button variant="outline-secondary mr-auto" @click=cancel()><i class="fa fa-reply"></i> Voltar</b-button>
		    </template>
	    </b-modal>

	    <b-modal id="modal-anexos-processo"
	             ref="modalAnexosProcesso"
	             size="lg"
	             header-bg-variant="primary"
	             header-text-variant="white"
	             cancel-title="Fechar"
	             footer-class="d-flex justify-content-center align-items-center">
		    <template #modal-header="{ close }" v-if="processoSelecionado">
			    <h5 class="modal-title">Anexos do processo {{formatarCNJ(processoSelecionado.cnj)}}</h5>
			    <button
				    class="close text-white ml-1"
				    @click="close()"
				    aria-label="close"
			    >
				    &times;
			    </button>
		    </template>

		    <b-row>
			    <b-col xs="12" md="12" class="mx-auto">
				    <div id="messages" v-if="messageModal.message !== null">
					    <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
				    </div>
			    </b-col>
		    </b-row>

		    <b-row>
			    <b-col xs="12" v-if="processoSelecionado != null">
				    <b-row v-for="anexo in processoSelecionado.peticionamentoDocumentos" class="mb-1">
					    <b-col>
						    <b-link @click="baixarAnexo(anexo.codPeticionamentoDocumento, anexo.anexo)" class="m-0 p-0 text-center">
							    {{anexo.anexo}}
						    </b-link>
						    <b-link @click="excluirAnexo(anexo.codPeticionamentoDocumento)" class="ml-lg-1 p-0 text-center">
							    <i class="fa fa-trash text-warning"></i>
						    </b-link>
					    </b-col>
				    </b-row>

				    <b-row v-if="processoSelecionado != null && !processoSelecionado.enviada">
					    <b-col sm="12" lg="12">
						    <b-form-group label="Anexar arquivos: ">
							    <b-form-file
								    class="text-nowrap text-truncate"
								    v-model="arquivos"
								    multiple
								    browse-text="Selecionar..."
								    placeholder="Selecione ou arraste um ou mais arquivos aqui..."
								    drop-placeholder="Arraste um arquivo aqui..."
								    accept="pdf"
								    @input="uploadAnexos"
							    ></b-form-file>
						    </b-form-group>
					    </b-col>
				    </b-row>
			    </b-col>
		    </b-row>

		    <template v-slot:modal-footer="{ cancel }">
			    <b-button
				    class="fonte-branca ml-1"
				    variant="secondary"
				    @click.prevent="cancel()"
			    >
				    <i class="fa fa-times"></i> Cancelar
			    </b-button>
			    <b-button
				    class="fonte-branca ml-1"
				    variant="primary"
				    @click="executeUpload()"
				    :disabled="processoSelecionado != null && processoSelecionado.enviada">
				    <i class="fa fa-paperclip"></i> Anexar Arquivo
			    </b-button>
		    </template>
	    </b-modal>

	    <b-modal
		    id="modal-limpar-minuta"
		    ref="modalLimparMinuta"
		    size="md"
		    scrollable
		    centered
		    header-bg-variant="danger"
		    title="Confirmar Exclusão de Minuta"
		    footer-class="d-flex justify-content-center align-items-center"
	    >
		    <p>
			    Confirma a exclusão das minutas dos prazos abaixo? (essa operação é
			    irreversível)
		    </p>
		    <p v-for="minuta in listarSelecionadosGerados()">
			    - {{ formatarCNJ(minuta.cnj) }}
		    </p>
		    <template v-slot:modal-footer="{ cancel }">
			    <b-button
				    class="fonte-branca ml-1"
				    variant="secondary"
				    @click.prevent="cancel()"
			    >
				    <i class="fa fa-times"></i> Cancelar
			    </b-button>
			    <b-button
				    class="fonte-branca ml-1"
				    variant="danger"
				    @click="excluirMinutas()"
			    >
				    <i class="fa fa-trash"></i> Confirmar Exclusão
			    </b-button>
		    </template>
	    </b-modal>

	    <!-- Modal Limpar prazos -->

	    <b-modal
		    id="modal-limpar-prazos" size="md" ref="modalLimparPrazos"
		    scrollable centered
		    header-bg-variant="danger"
		    header-text-variant="white"
		    title="Confirmar a Limpeza dos Cumpridos"
		    footer-class="d-flex justify-content-center align-items-center"
	    >
		    <p>
			    Confirma a limpeza dos prazos cumpridos? (essa operação é irreversível)
		    </p>

		    <template v-slot:modal-footer="{ cancel }">
			    <b-button
				    class="fonte-branca ml-1"
				    variant="secondary"
				    @click.prevent="cancel()"
			    >
				    <i class="fa fa-reply"></i> Cancelar
			    </b-button>
			    <b-button
				    class="fonte-branca ml-1"
				    variant="danger"
				    @click.prevent="limparCumpridos();cancel()"
			    >
				    <i class="fa fa-trash"></i> Confirmar Limpeza
			    </b-button>
		    </template>
	    </b-modal>

	    <b-modal id="modal-editar-minuta"
	             ref="modalEditarMinuta"
	             size="xl"
	             scrollable centered
	             header-bg-variant="primary"
	             header-text-variant="white"
	             footer-class="d-flex justify-content-center align-items-center"
	             cancel-title="Fechar">
		    <template #modal-header="{ close }">
			    <h5 class="modal-title">
				    Minuta do processo {{formatarCNJ(processoSelecionado.cnj)}}
			    </h5>
			    <b-button variant="cda" 
			              @click="imprimirMinuta"
			              class="py-0 ml-auto">
				    <i class="fa fa-file-pdf-o"></i> Imprimir
			    </b-button>
			    <button
				    class="close text-white ml-1"
				    @click="close()"
				    aria-label="close"
			    >
				    &times;
			    </button>
		    </template>

		    <b-row>
			    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
				    <vue-editor id="editor" v-model="minutaEditar" :disabled="processoSelecionado != null && processoSelecionado.enviada"></vue-editor>
			    </b-col>
		    </b-row>

		    <template v-slot:modal-footer="{ cancel }">
			    <b-button
				    class="fonte-branca ml-1"
				    variant="secondary"
				    @click.prevent="cancel()"
			    >
				    <i class="fa fa-times"></i> Cancelar
			    </b-button>
			    <b-button
				    class="fonte-branca ml-1"
				    variant="primary"
				    @click="alterarMinuta()"
				    :disabled="processoSelecionado != null && processoSelecionado.enviada">
				    <i class="fa fa-save"></i> Salvar
			    </b-button>
		    </template>
	    </b-modal>

	    <b-modal id="modal-visualizar-peticao"
	             ref="modalVisualizarPeticao"
	             size="xl"
	             scrollable centered
	             header-bg-variant="primary"
	             header-text-variant="white"
	             footer-class="d-flex justify-content-center align-items-center"
	             cancel-title="Fechar">
		    <template #modal-header="{ close }">
			    <h5 class="modal-title">
				    Petição do processo {{formatarCNJ(processoSelecionado.cnj)}}
			    </h5>
			    <b-button variant="cda" 
			              @click="imprimirPeticao"
			              class="py-0 ml-auto">
				    <i class="fa fa-file-pdf-o"></i> Imprimir
			    </b-button>
			    <button
				    class="close text-white ml-1"
				    @click="close()"
				    aria-label="close"
			    >
				    &times;
			    </button>
		    </template>

		    <vue-pdf-embed v-if="pdfPeticao" :source="pdfPeticao" ref="pdfPeticaoEmbededRef" />

		    <template v-slot:modal-footer="{ cancel }">
			    <b-button variant="outline-secondary mr-auto" @click=cancel()><i class="fa fa-reply"></i> Voltar</b-button>
		    </template>
	    </b-modal>

	    <b-modal
		    id="modal-bloqueio-minuta"
		    ref="modalBloqueioMinuta"
		    size="md"
		    scrollable centered
		    header-bg-variant="primary"
		    header-text-variant="white"
		    footer-class="d-flex justify-content-center align-items-center"
            title="Editar Minuta"
            cancel-title="Fechar">

		    <b-row>
			    <b-col xs="12" md="12" class="mx-auto">
				    <div id="messages" v-if="messageModal.message !== null">
					    <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
				    </div>
			    </b-col>
		    </b-row>

		    <p>
			    Essa minuta está bloqueada com {{ minutaBloqueio.usuarioAlteracao }} (última alteração no arquivo
			    ocorreu no dia {{ minutaBloqueio.dataAlteracao }})
		    </p>
		    <p>
			    Deseja desbloquear a minuta para sua edição?
		    </p>
		    <template v-slot:modal-footer="{ cancel }">
			    <b-button
				    class="fonte-branca ml-1"
				    variant="secondary"
				    @click.prevent="cancel()"
			    >
				    <i class="fa fa-times"></i> Não
			    </b-button>
			    <b-button
				    class="fonte-branca ml-1"
				    variant="primary"
				    @click="bloquearMinuta"
			    ><i class="fa fa-pencil"></i> Sim</b-button>
		    </template>
	    </b-modal>

	    <b-modal
		    id="modal-peticionar"
		    ref="modalPeticionar"
		    size="md"
		    scrollable
		    centered
		    header-bg-variant="primary"
		    header-text-variant="white"
		    footer-class="d-flex justify-content-center align-items-center"
		    @shown="onOpenModalPesquisaPeticionar"
		    @hide="impedirFechar"
	    >
		    <template #modal-header="{ cancel }">
			    <h5 class="modal-title">Enviar Peticionamento - Assinar</h5>
			    <button type="button" aria-label="Close"
			            class="close text-white"
			            :disabled="enviando"
			            @click.prevent="cancel()">
				    &times;
			    </button>
		    </template>

		    <b-row>
			    <b-col xs="12" md="12" class="mx-auto">
				    <div id="messages" v-if="messageModal.message !== null">
					    <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
				    </div>
			    </b-col>
		    </b-row>

		    <p>
			    Assinar e peticionar nos prazos selecionados abaixo:
		    </p>
		    <div v-if="tramitacoesEnviadas.length > 0">
			    <p v-for="tramitacao in tramitacoesEnviadas" v-if="tramitacao.sucesso">
				    - {{ formatarCNJ(tramitacao.cnj) + protocoloEnvio(tramitacao.cnj)}}
			    </p>
		    </div>
		    <div v-else>
			    <p v-for="minuta in listarSelecionadosPrazo()">
				    - {{ formatarCNJ(minuta.cnj)}}
			    </p>
		    </div>

		    <div v-if="tramitacoesEnviadas.length > 0 && tramitacoesEnviadas[0].fichasNaoEncontradas.length > 0">
			    <p class="mt-lg-5">
				    Ficha não encontrada para tramitação
			    </p>

			    <p v-for="ficha in tramitacoesEnviadas[0].fichasNaoEncontradas">
				    - {{ formatarCNJ(ficha) }}
			    </p>
		    </div>


		    <div class="div-btn-limpar-minuta mt-lg-5 mb-lg-5" v-if="tramitacoesEnviadas.length > 0">
			    <div>
				    <p>Prazos cumpridos com êxito!</p>
			    </div>
		    </div>

		    <div class="div-btn-limpar-minuta mt-lg-5 mb-lg-5" v-else-if="enviando">
			    <div>
				    <p>Aguarde! Enviando para o Projudi...</p>
			    </div>
		    </div>
		    
		    <b-row v-else-if="!enviando">
			    <b-col xs="6" sm="12" md="12" lg="12" xl="12">
				    <div v-if="!apenasGrupoAsses && exibirAssinatura" class="certificado">
					    <Certificado
						    ref="certificadoBry"
						    :param="parametrosAssinatura"
						    @finalizarAssinatura="processarArquivoAssinado($event)"
						    @erroAssinatura="processarErroAssinatura($event)"/>
				    </div>
			    </b-col>
		    </b-row>

		    <template v-slot:modal-footer="{ cancel }">
			    <b-button
				    class="fonte-branca ml-1"
				    variant="secondary"
				    @click.prevent="cancel()"
				    :disabled="enviando"
			    >
				    <i class="fa fa-times"></i> Cancelar
			    </b-button>
		    </template>
	    </b-modal>
	    <CompLoading ref="loading"/>
    </div>
  </template>
  <script>
  import agendaPrazosData from './agendaPrazosData.js'
  import axios from 'axios'
  import formatarMixins from '../../../mixins/formatarMixins'
  import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
  import ExtratoCda from "../../shared/components/ExtratoCda";
  import { VueEditor } from "vue2-editor";
  import Certificado from "assinador-bry";
  import apiCentralSeguranca from '@/api/centralseguranca';
  import CompLoading from "@/views/shared/components/CompLoading.vue";

  const urlApi = process.env.VUE_APP_ROOT_API;
  const StatusPrazoEnum = Object.freeze({
    PENDENTE_CIENCIA: "Aguardando Leitura",
    PENDENTE_RESPOSTA: "Aberto",
    CUMPRIDO: "Cumprido"
  })
  const TribunalEnum = Object.freeze({
    PROJUDI_1GRAU: "1º",
    PROJUDI_2GRAU: "2º"
  })

  export default {
    mixins: [ formatarMixins ],
    components: {
	  CompLoading,
      VuePdfEmbed,
      ExtratoCda,
	  VueEditor,
      Certificado
    },
    props: {
      perfil: {
        type: String,
        default: "prazo",
      },
      perPage: {
        type: Number
      },
      filtros: {
        type: Object
      },
      sortField: {
        type: String,
        default: ""
      },
    },
    watch: {
      perfil: function() {
        this.atualizarFields()
      },
      filtros: function() {
        this.listarAgendaPrazos()
      },
      sortField: function() {
        this.listarAgendaPrazos()
      },
    },
    mounted() {
      this.atualizarFields()
      this.listarAgendaPrazos()
      this.atualizaDataHoraUltimaAtualizacao()
      this.carregarCertificado()
      this.verificarPermissaoUsuario()

      window.addEventListener("scroll", this.onScroll);
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.onScroll)
    },
    data() {
      return {
        anotacaoProcesso: {},
        dataHoraUltimaAtualizacao: "",
        sincronizando: false,
        statusProcessamento: null,
        statusSincronizacao: {},
        processoImportante: {},
        selecionados: [],
        processoSelecionado: null,
        todosSelecionados: false,
        selecao: null,
          sortBy: "cda",
          sortDesc: false,
        currentPage: 1,
        rows: 0,
        ...agendaPrazosData.data(),
        items: [],
        itemsVencimento: [],
        qtdDiasCalcularPrazo: null,
        dataVencimentoManual: null,
        movimentosProcesso: [],
        palavrasChave: [],
        pdf: null,
        pdfName: '',
        isLoadingPdf: false,
        dadosDossie: null,
        dadosCDA: null,
        selecaoCdas: true,
        isLoadingDossie: false,
        isLoadingCDA: false,
	      relCdaOpcoes: [
		      { text: "Todos", value: "TODOS" },
		      { text: "Só Princ.", value: "PRINCIPAL" },
		      { text: "Não gerar", value: "SEMCDA" }
	      ],
	      modelo: null,
	      modeloSelecionado: null,
	      modelosPesquisa: [],
	      modelos: [],
	      modelosApplicados: [],
	      camposModelo: [
		      {
			      key: "selecao",
			      sortable: false,
			      label: "Sel.",
		      },
		      {
			      key: "id",
			      sortable: false,
			      label: "Id.",
			      visible: false,
		      },
		      {
			      key: "descricao",
			      sortable: false,
			      label: "Descritivo",
			      visible: false,
		      },
		      {
			      key: "exibir",
			      sortable: false,
			      label: "Ver",
			      visible: false,
		      }
	      ],
	      filtroIdModelo: null,
	      filtroDescritivoModelo: null,
	      arquivos: [],
	      arquivosConvertidos: [],
	      messageModal: {
		      message: null,
		      variant: null
	      },
	      uploadIniciado: false,
	      minutaEditar: null,
	      minutaBloqueio: {
		      usuarioAlteracao: null,
		      dataAlteracao: null
	      },
	      listaPdfsRetorno: [ ],
	      cpfUsuario: null,
	      pdfPeticao: null,
	      enviando: false,
	      apenasGrupoAsses: false,
	      tramitacoesEnviadas: [],
	      exibirAssinatura: false,
	      parametrosAssinatura: {
		      config: {
			      padraoAssinatura: "1",
			      tipoAssinatura: "Attached",
			      incluiCadeia: true,
		      },
		      filters: {
			      CPFS:[]
		      },
		      nomeBotaoAssinar: 'Assinar e Peticionar',
		      ambiente: process.env.VUE_APP_BRY_AMBIENTE,
		      arquivo: this.listaPdfsRetorno,
		      token: JSON.parse(this.$store.getters.getUser).access_token,
		      consumerId : 'PGEPROAJU',
		      realizarDownloadArquivoAssinado: false
	      },
      };
    },
    computed: {
      toggleAvancar() {
        return this.selecionados.length === 0;
      },
      visibleFields() {
        return this.fields.filter((field) => field.perfil === this.perfil);
      },
      procurador() {
        return this.$store.getters.getAgendaProcurador;
      }
    },
    methods: {
      onScroll(e) {
          const errors = this.$store.getters.getMessages.errors
          var positionHeader = 65
          if (errors && errors.length > 0) {
            positionHeader = positionHeader + 62
          }

          var thColunas = document.getElementsByClassName("coluna-fixa")[0].parentElement.parentElement.parentElement;

          if(window.scrollY <= 45) {
              thColunas.style.position = null;
              thColunas.style.top = null;
              thColunas.style = 'z-index: -1;';
          } else {
              thColunas.style = 'z-index: 1; position: sticky; top: '+(window.scrollY - positionHeader)+'px;'
          }
      },
      getStatusPrazoEnum(val) {
        return StatusPrazoEnum[val];
      },
      getTribunalEnum(val) {
        return TribunalEnum[val];
      },
      openFilter(campo, tipo, values, mask, event) {
          this.$emit('openFilterPopup', campo, tipo, values, mask, event);
      },
      selecionarCnj(cnj) {
        this.items.forEach(function(item) {
          if (item.cnj === cnj) {
            item.selecao = !item.selecao;
          }
        });
      },
      voltar() {
        this.$emit("voltar");
      },
      avancar() {
        this.$emit("avancar");
      },
      selecionar(item) {
        if (item.selecao) {
          if (!this.selecionados.includes(item)) {
            this.selecionados.push(item);
          }
        } else {
          this.selecionados = this.selecionados.filter(function(itemSel) {
              return itemSel != item
          })
        }

        this.$emit("atualizarSelecionados", this.selecionados);
      },
      selecionarTudo() {
        this.selecionados = [];

	      if(this.todosSelecionados && this.perfil == 'minuta') {
		      for (var item of this.items) {
				  if (item.enviada) {
					  item.selecao = false;
				  } else {
					  item.selecao = true;
					  this.selecionados.push(item);
				  }
		      }
	      } else {
		      if (this.todosSelecionados) {
			      this.selecionados = this.items
		      }
		      this.items.forEach((item) => {
			      item.selecao = this.todosSelecionados;
		      });
	      }

        this.$emit("atualizarSelecionados", this.selecionados);
      },
      desselecionarTudo() {
        this.selecionados = [];
        this.todosSelecionados = false;
        this.$emit("atualizarSelecionados", this.selecionados);
      },
      selecionarRegistrosMinuta() {
	      let selecionadosTemp = [];

	      for (var item of this.selecionados) {
		      if (item.enviada) {
			      item.selecao = false;
		      } else {
			      item.selecao = true;
			      selecionadosTemp.push(item);
		      }
	      }
		  
		  this.selecionados = selecionadosTemp

	      this.$emit("atualizarSelecionados", this.selecionados);
      },
      imprimir() {
        window.open(
          "http://beta.pr.gov.br/sistemas/pge/docs/ReceitaDiversa.pdf",
          "_blank"
        );
      },
      async listarColunasTabelas(funcionalidade) {
        const token = JSON.parse(this.$store.getters.getUser).access_token;

        axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': token
            }
          })
          .then((response) => {
            const data = response.data

            data.forEach(el => {
              if (el.ativo) {
                const field = this.tbFieldsAgenda.filter(fa => fa.label == el.descricao)[0]
                if (field)
                  this.fieldsTabela = [ ...this.fieldsTabela, field ]
              }
            });
          })
          .catch((error) => {
            error
          })
      },
      async atualizarFields() {
        this.fieldsTabela = [ ...this.tbCommonFields ]
        if (this.perfil == 'prazo') {
          this.tbFieldsAgenda = [ ...this.tbCommonFields, ...this.tbFieldsPrazo  ]
          await this.listarColunasTabelas("Agenda Prazos - Aba Prazos")
        } else if (this.perfil == 'processo') {
          this.tbFieldsAgenda = [ ...this.tbCommonFields, ...this.tbFieldsProcesso ]
          await this.listarColunasTabelas("Agenda Prazos - Aba Processo e Devedor")
        } else if (this.perfil == 'minuta') {
          this.tbFieldsAgenda = [ ...this.tbCommonFields, ...this.tbFieldsMinuta ]
          await this.listarColunasTabelas("Agenda Prazos - Aba Minuta")
        }
      },
      listarAgendaPrazos() {
        this.reiniciaCores();
        this.selecionados = [];
        const token = JSON.parse(this.$store.getters.getUser).access_token;
        const codProcurador = this.procurador.id

        const params = {
          sort: this.sortField,
          ...this.filtros
        }
        axios.get(`${urlApi}/v1/prazos/procurador/${codProcurador}`, {
          params: params,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          }
        })
        .then((response) => {
          const data = response.data
          this.items = data.resultado
          this.rows = data.rows
          this.populaEstilos()
        })
        .catch((error) => {
          error
        })
      },
      reiniciaCores() {
        this.cnjColorsAvailable = [];
        this.cnjColorsAvailable.push(...this.colors);
        this.cnjColorsMap = new Map();
        this.cnpjColorsAvailable = [];
        this.cnpjColorsAvailable.push(...this.colors);
        this.cnpjColorsMap = new Map();
      },
      populaEstilos() {
        for(let i = 0; i<this.items.length; i++) {
          let cores = {}

          cores.cnj = this.getCNJColor(this.items[i].cnj)
          cores.selecao = cores.cnj

          cores.devedor = this.getCNPJColor(this.items[i].cnpjDevedor)

          if (this.items[i].statusPrazo == 'CUMPRIDO') {
            cores.statusPrazo = "EFEF71"
          }
          
          if (new Date(this.items[i].dataVenc).setHours(0,0,0,0) == new Date().setHours(0,0,0,0)) {
            cores.dataVenc = "FFC8CE"
          }
          if (new Date(this.items[i].meuVenc).setHours(0,0,0,0) == new Date().setHours(0,0,0,0)) {
            cores.meuVenc = "FFC8CE"
          }
          
          this.items[i]._cellVariants = cores;
        }
      },
      limparCumpridos() {
        this.selecionados = [];
        this.$emit("atualizarSelecionados", this.selecionados);
        const token = JSON.parse(this.$store.getters.getUser).access_token;
        const codProcurador = this.procurador.id

        axios.post(`${urlApi}/v1/prazos/procurador/${codProcurador}/limparcumpridos`, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(() => {
          this.listarAgendaPrazos()
	      this.desselecionarTudo()
        });
      },
      onOpenModalAbrirPrazo() {
        this.statusProcessamento = null;
      },
      abrirPrazos() {
        this.statusProcessamento = "START";
        const token = JSON.parse(this.$store.getters.getUser).access_token;
        const codProcurador = this.procurador.id
        const idsPrazoProcurador = this.selecionados.map(val => val.codPrazoProcurador)

        axios.post(`${urlApi}/v1/prazos/procurador/${codProcurador}/abrirprazo`, {idsPrazoProcurador: idsPrazoProcurador},
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': token
              }
            }).then(() => {
              this.statusProcessamento = "END"
	          this.desselecionarTudo()
            }).catch(() => {
              this.statusProcessamento = "ERRO"
            });
      },
      calcularPrazos() {
        const token = JSON.parse(this.$store.getters.getUser).access_token;
        const codProcurador = this.procurador.id
        
        axios.post(`${urlApi}/v1/prazos/procurador/${codProcurador}/calcularprazo`, { dias: this.qtdDiasCalcularPrazo }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(() => {
          this.listarAgendaPrazos()
          this.qtdDiasCalcularPrazo = null
	      this.desselecionarTudo()
        }).catch(() => {
          this.qtdDiasCalcularPrazo = null
        });
      },
      onOpenModalTabelaVencimentos() {
        this.itemsVencimento = []
        const token = JSON.parse(this.$store.getters.getUser).access_token;
        const codProcurador = this.procurador.id

        axios.get(`${urlApi}/v1/prazos/procurador/${codProcurador}/prazos`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response) => {
          var dataAtual = new Date()
          dataAtual.setHours(0,0,0,0)

          var total = 0
          var linhaDataAtual = {
            isData: true,
            texto: '',
            dataVencimento: new Date(),
            quantidade: 0,
            _rowVariant: "danger",
          }

          response.data.forEach(self => {
            total += self.quantidade
            if (self.dataVencimento == dataAtual.getTime()) {
              linhaDataAtual.quantidade = self.quantidade
            } else {
              this.itemsVencimento.push({
                isData: self.dataVencimento != null,
                texto: !self.dataVencimento ? 'Sem Data' : '',
                dataVencimento: self.dataVencimento ? new Date(self.dataVencimento) : '',
                quantidade: self.quantidade,
              })
            }
          })

          this.itemsVencimento.unshift(linhaDataAtual)

          this.itemsVencimento.push({
            isData: false,
            texto: 'Total',
            dataVencimento: null,
            quantidade: total,
            _rowVariant: "secondary",
          })
        })
      },
      onOpenModalSincronizar() {
        this.sincronizando = false;
        this.statusSincronizacao = {};
        this.atualizaDataHoraUltimaAtualizacao();
      },
      atualizaDataHoraUltimaAtualizacao() {
        const urlApi = process.env.VUE_APP_ROOT_API
        const token = JSON.parse(this.$store.getters.getUser).access_token

        axios.post(`${urlApi}/v1/procurador/obter`, this.procurador.id, {
              headers: {
                  'Authorization': token,
                  'Content-Type': 'application/json',
              }
          })
          .then(response => {
              let self = response.data
              this.$store.commit('setAgendaProcurador', {
                name: self.nome,
                id: self.codProcurador,
                grupoTrabalho: self.grupoTrabalho ? self.grupoTrabalho.nome : null,
                nomeFormatado: self.nome + (self.grupoTrabalho ? " (" + self.grupoTrabalho.nome + ")" : ""),
                dataHoraUltimaSincronizacao: self.dataHoraUltimaSincronizacao
              });
              this.dataHoraUltimaAtualizacao = response.data.dataHoraUltimaSincronizacao
          }).catch((error) => {
              this.exibirErro(error)
          })
      },
      anotarVencimentoManual() {
        const token = JSON.parse(this.$store.getters.getUser).access_token;
        
        const prazoManual = { 
          prazoManual: this.dataVencimentoManual,
          codigosPrazoProcurador: this.selecionados.map(self => self.codPrazoProcurador)
        }

        axios.post(`${urlApi}/v1/prazos/prazomanual`, prazoManual, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(() => {
          this.listarAgendaPrazos()
          this.dataVencimentoManual = null
	      this.desselecionarTudo()
        }).catch(() => {
          this.dataVencimentoManual = null
        });
      },
      onOpenModalVerMovimentos() {
        this.movimentosProcesso = []
        const token = JSON.parse(this.$store.getters.getUser).access_token;
        this.processoSelecionado = this.selecionados[0]
        this.carregaPalavrasChave();

        axios.get(`${urlApi}/v1/prazos/movimentos/${this.processoSelecionado.cnj}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response) => {
          this.movimentosProcesso = response.data
        })
      },
      carregaPalavrasChave() {
        const token = JSON.parse(this.$store.getters.getUser).access_token;

        axios.get(`${urlApi}/v1/palavrachave/ativos`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response) => {
          this.palavrasChave = response.data
        })
      },
      onOpenModalVerPdf() {
        this.pdf = null
        this.isLoadingPdf = true
        const token = JSON.parse(this.$store.getters.getUser).access_token;
        const codProcurador = this.procurador.id
        this.processoSelecionado = this.selecionados[0]

        axios.get(`${urlApi}/v1/prazos/${codProcurador}/processo/${this.processoSelecionado.codPrazoProcurador}/pdf`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then( (response) => {
          const arquivos = response.data
          if (arquivos.length > 0) {
            const arq = arquivos[0]
            this.pdf = 'data:application/pdf;base64,' + arq.conteudo
            this.pdfName = arq.nome
          }
          this.isLoadingPdf = false
        })
      },
      imprimirVerPdf() {
        this.$refs.pdfEmbededRef.download(this.pdfName)
      },
	  imprimirPeticao() {
        this.$refs.pdfPeticaoEmbededRef.download('peticao.pdf')
      },
      estilizaPalavraChave(termo) {
        let retorno = termo;
        for(let i = 0; i < this.palavrasChave.length; i++) {
          let palavraChave = this.palavrasChave[i];
          let regex = new RegExp("(?<!\p{L})" + palavraChave.palavra + "(?!\p{L})", "ig");
          let match = retorno.match(regex)
          if (match != null) {
            for(let j = 0; j < match.length; j++) {
              retorno = retorno.replace(
                match[j],
                '<span style="background: ' + palavraChave.cor + '">'+match[j]+'</span>')
            }
          }
        }
        return retorno;
      },
      imprimirAnotacaoProcesso() {
        const token = JSON.parse(this.$store.getters.getUser).access_token;

        axios.post(`${urlApi}/v1/prazos/imprimiranotacaoprocesso`, {
          anotacao: this.anotacaoProcesso.anotacao, numeroUnico: this.formatarCNJ(this.anotacaoProcesso.numeroUnico) 
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            responseType: 'arraybuffer'
        }).then(response => {
          this.downloadPDF(response, 'relatorio-anotacao.pdf');
        })
      },
      imprimirMovimentosProcesso() {
        const token = JSON.parse(this.$store.getters.getUser).access_token;

        axios.post(`${urlApi}/v1/prazos/imprimirmovimentosprocesso`, {
          listaMovimentos: this.movimentosProcesso, numeroUnico: this.formatarCNJ(this.processoSelecionado.cnj) 
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            responseType: 'arraybuffer'
        }).then(response => {
          this.downloadPDF(response, 'relatorio-movimentos.pdf');
        })
      },
      downloadPDF(response, nome) {
        let blob = new Blob([response.data], { type: 'application/pdf' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = nome;
        link.click();
      },
      downloadAnexo(response, nome) {		
	      const url = window.URL.createObjectURL(new Blob([response.data]));
	      const link = document.createElement('a');
	      link.href = url;
	      link.setAttribute('download', nome);
	      document.body.appendChild(link);
	      link.click();
      },
      sincronizarMovimentos() {
        const token = JSON.parse(this.$store.getters.getUser).access_token;
        const codProcurador = this.procurador.id
        const numeroProcesso = this.processoSelecionado.cnj

        axios.post(`${urlApi}/v1/prazos/procurador/${codProcurador}/movimentos/${numeroProcesso}/sincronizar`, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(() => {
          this.processoSelecionado.dataHoraConsultaMovimento = new Date().toISOString();
          this.onOpenModalVerMovimentos();
        })
      },
      getCNJColor(cnj) {
        let corCnj = this.cnjColorsMap.get(cnj);
        if (corCnj == null) {
          var count = 0
          this.items.forEach(it => {
            if (it.cnj == cnj) {
              count++
            }
          })

          if (count > 1) {
            this.cnjColorsMap.set(cnj, this.cnjColorsAvailable.shift())
            return this.cnjColorsMap.get(cnj)
          }
        } else {
          return corCnj
        }
      },
      getCNPJColor(cnpj) {
        if (!cnpj) {
          return "";
        }
        let cnpjRaiz = cnpj.substring(0,8);

        let corCnpj = this.cnpjColorsMap.get(cnpjRaiz);
        if (corCnpj != null) {
          return corCnpj
        }
        var count = 0
        this.items.forEach(it => {
          if (it.cnpjDevedor && it.cnpjDevedor.substring(0,8) == cnpjRaiz) {
            count++
          }
        })

        if (count > 1) {
          this.cnpjColorsMap.set(cnpjRaiz, this.cnpjColorsAvailable.shift())
          return this.cnpjColorsMap.get(cnpjRaiz)
        }
      },
      async copiarCNJ(cnj) {
        let textToCopy = cnj.replace(/[^a-zA-Z0-9 ]/g, '');
        this.copyToClipboard(textToCopy)
      },
      async copiarCNJDossie(cnj) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(cnj);
        } else {
            var textArea = document.getElementById('textareaCopyCnjDossie'+cnj);
            textArea.style.visibility = "visible";
            textArea.select();
            document.execCommand('copy');
            textArea.style.visibility = "hidden";
        }
      },
      async copyToClipboard(textToCopy) {
        try{
          if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(textToCopy);
          } else {
              // Use the 'out of viewport hidden text area' trick
              const textArea = document.createElement("textarea");
              textArea.value = textToCopy;
                  
              // Move textarea out of the viewport so it's not visible
              textArea.style.position = "absolute";
              textArea.style.left = "-999999px";
                  
              document.body.prepend(textArea);
              textArea.select();

              try {
                  document.execCommand('copy');
              } finally {
                  textArea.remove();
              }
          }
        } catch (e) {
          console.log(e)
        }
      },
      getCorProcessoImportante(item) {
        return item.processoImportante == null || item.processoImportante.ativo == false ?
          "#BEBEBE" : //cinza
          "#B92A24" //vermelho
      },
      getCorAnotacao(item) {
        return item.anotacaoProcesso == null || item.anotacaoProcesso.anotacao == null || item.anotacaoProcesso.anotacao.trim().length == 0 ?
          "#BEBEBE" : //cinza
          "#4C6E7A" //azul
      },
      async iniciarModalAnotacao(item) {
	      const token = JSON.parse(this.$store.getters.getUser).access_token;
	      await axios.get(`${urlApi}/v1/prazos/anotacao/${item.cnj}`, {
		      headers: {
			      'Content-Type': 'application/json',
			      'Authorization': token
		      }
	      }).then((response) => {
		      item.anotacaoProcesso = response.data
	      })

	      if (!item.anotacaoProcesso || !item.anotacaoProcesso.numeroUnico) {
		      this.anotacaoProcesso = {
			      anotacao: '',
			      numeroUnico: item.cnj
		      }
	      } else {
		      this.anotacaoProcesso = {...item.anotacaoProcesso};
	      }
      },
      salvarAnotacao() {
        const token = JSON.parse(this.$store.getters.getUser).access_token;

        axios.post(`${urlApi}/v1/prazos/anotacao`, this.anotacaoProcesso, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(() => {
          this.listarAgendaPrazos()
        });

      },
      async iniciarModalProcessoImportante(item) {
	      const token = JSON.parse(this.$store.getters.getUser).access_token;
	      await axios.get(`${urlApi}/v1/prazos/importante/${item.cnj}`, {
		      headers: {
			      'Content-Type': 'application/json',
			      'Authorization': token
		      }
	      }).then((response) => {
		      item.processoImportante = response.data
	      })

	      if (!item.processoImportante || item.processoImportante == null) {
		      this.processoImportante = {
			      anotacao: '',
			      numeroUnico: item.cnj
		      }
	      } else {
		      this.processoImportante = {...item.processoImportante};
	      }
      },
      salvarProcessoImportante() {
        this.processoImportante.ativo = true;
        
        const token = JSON.parse(this.$store.getters.getUser).access_token;

        axios.post(`${urlApi}/v1/prazos/importante`, this.processoImportante, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(() => {
          this.listarAgendaPrazos()
        });
      },
      excluirProcessoImportante() {
        const token = JSON.parse(this.$store.getters.getUser).access_token;

        axios.delete(`${urlApi}/v1/prazos/importante/${this.processoImportante.numeroUnico}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(() => {
          this.listarAgendaPrazos()
        });
      },
      sincronizar() {
        this.sincronizando = true;
        this.statusSincronizacao = {};
        
        const token = JSON.parse(this.$store.getters.getUser).access_token;
        const codProcurador = this.procurador.id

        axios.post(`${urlApi}/v1/prazos/procurador/${codProcurador}/sincronizar`, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(() => {
          this.atualizaStatusSincronizacao()
          this.desselecionarTudo()
        });
      },
      atualizaStatusSincronizacao() {
        const token = JSON.parse(this.$store.getters.getUser).access_token;
        const codProcurador = this.procurador.id

        axios.get(`${urlApi}/v1/prazos/procurador/${codProcurador}/sincronizar`, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': token
            }
          })
          .then((response) => {
            const data = response.data

            if (data.fim == null) {
              setTimeout(() => this.atualizaStatusSincronizacao(), 1000)
            } else {
              this.atualizaDataHoraUltimaAtualizacao();
              this.sincronizando = false;
            }

            this.statusSincronizacao = data;
          })
      },
      exibeIniciando(status) {
        return status != null && status != 'NAO_INICIADO'
      },
      exibeEnviada(status) {
        return this.exibeIniciando(status) && status != 'INICIANDO'
      },
      exibeEmProcessamento(status) {
        return this.exibeEnviada(status) && status != 'SOLICITACAO_ENVIADA'
      },
      exibeAtualizando(status) {
        return this.exibeEmProcessamento(status) && status != 'SOLICITACAO_ENVIADA'
      },
      negritoIfNovo(item) {
        let inclusaoRegistro = new Date(item.dataHoraInclusao).getTime();
        let atualizacaoProcurador = new Date(this.dataHoraUltimaAtualizacao).getTime();
        return inclusaoRegistro > atualizacaoProcurador ?
          "negrito" :
          ""
      },
      classDataAju(dataStr) {
        const diffMeses = this.calcularDiferencaEmMeses(dataStr)
        if (diffMeses < 24) {
          return ""
        } else if (diffMeses <= 42) {
          return " data-aju-fce5cd "
        } else if (diffMeses <= 60) {
          return " data-aju-f4cccc "
        } else if (diffMeses > 60) {
          return " data-aju-e06666 "
        }
      },
      calcularDiferencaEmMeses(dataStr) {
        const dataInicial = new Date(dataStr)
        const dataFinal = new Date()

        const anoInicial = dataInicial.getFullYear();
        const mesInicial = dataInicial.getMonth();
        const anoFinal = dataFinal.getFullYear();
        const mesFinal = dataFinal.getMonth();

        // Calcular a diferença em meses
        const diferencaEmMeses = (anoFinal - anoInicial) * 12 + (mesFinal - mesInicial);
        return diferencaEmMeses;
      },
      calcularDiferencaAnosEMeses(dataStr) {
        var diffInMonths = Math.trunc(this.calcularDiferencaEmMeses(dataStr));
        const diffInYears = Math.trunc(diffInMonths/12);

        diffInMonths = diffInMonths - diffInYears * 12

        return "("+ diffInYears +"a"+ diffInMonths+"m)"
      },
      onOpenModalVerCDA() {
        this.isLoadingCDA = true
        this.dadosCDA = null;
        this.processoSelecionado = this.selecionados[0]

        const token = JSON.parse(this.$store.getters.getUser).access_token;
        axios.get(`${urlApi}/v1/prazos/${this.processoSelecionado.cnj}/cda?incluirApensados=${this.selecaoCdas}`, 
          {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': token
              }
          }).then(response => {
            this.dadosCDA = response.data
            this.isLoadingCDA = false
          })
      },
      async copiarConteudoModalCDA() {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(this.dadosCDA.cdasString);
        } else {
            var textArea = document.getElementById('textareaCopy');
            textArea.style.visibility = "visible";
            textArea.select();
            document.execCommand('copy');
            textArea.style.visibility = "hidden";
        }
      },
      onOpenModalPesquisaTrovale() {
        this.processoSelecionado = this.selecionados[0]
      },
      onOpenModalVerDossie() {
        this.dadosDossie = null
        this.isLoadingDossie = true
        this.processoSelecionado = this.selecionados[0]
        const codProcurador = this.procurador.id
        const codPrazoProcurador = this.processoSelecionado.codPrazoProcurador
        this.carregaPalavrasChave();

        const token = JSON.parse(this.$store.getters.getUser).access_token;
        axios.get(`${urlApi}/v1/prazos/procurador/${codProcurador}/dossie/${codPrazoProcurador}`, 
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(response => {
          this.dadosDossie = response.data
          this.isLoadingDossie = false
        }).catch(e => {
          this.isLoadingDossie = false
        })
      },
      async copiarConteudoModalDossie() {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(this.dadosDossie.conteudoCopiar);
        } else {
            var textArea = document.getElementById('textareaCopyDossie');
            textArea.style.visibility = "visible";
            textArea.select();
            document.execCommand('copy');
            textArea.style.visibility = "hidden";
        }
      },
      exportarTrovaleCSV() {
        this.exportarTrovale('CSV', 'Pesquisa_Trovale.csv');
      },
      exportarTrovalePDF() {
        this.exportarTrovale('PDF', 'Pesquisa_Trovale.pdf');
      },
      exportarTrovale(tipo, nomeArquivo) {
        const codPrazoProcurador = this.processoSelecionado.codPrazoProcurador
        const token = JSON.parse(this.$store.getters.getUser).access_token;

        axios.get(`${urlApi}/v1/prazos/${codPrazoProcurador}/trovale/exportar?tipo=${tipo}`, 
          {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': token
              },
              responseType: 'arraybuffer'
          }).then(response => {
            if (tipo == 'CSV') {
              this.downloadFile(response, nomeArquivo);
            } else if (tipo == 'PDF') {
              this.downloadPDF(response, nomeArquivo);
            }
          }).catch(e => {
            this.isLoadingDossie = false
         })
      },
      downloadFile(response, nome) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', nome);
          document.body.appendChild(link);
          link.click();
      },
      imprimirDossie() {
          const token = JSON.parse(this.$store.getters.getUser).access_token;

          axios.post(`${urlApi}/v1/prazos/dossie/imprimir`, {
            nomeDevedor: this.dadosDossie.nomeDevedor, 
            processos: this.dadosDossie.processos
          }, {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': token
              },
              responseType: 'arraybuffer'
          }).then(response => {
            this.downloadPDF(response, 'relatorio-ver-dossie.pdf');
          })
      },
      imprimirCDAs() {
        const token = JSON.parse(this.$store.getters.getUser).access_token;

          axios.post(`${urlApi}/v1/prazos/cda/imprimir`, {
            qtdProcessos: this.dadosCDA.qtdProcessos, 
            valorTotal: this.dadosCDA.valorTotal,
            cdas: this.dadosCDA.cdas
          }, {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': token
              },
              responseType: 'arraybuffer'
          }).then(response => {
            this.downloadPDF(response, 'relatorio-ver-cdas.pdf');
          })
      },
      abrirModalExtratoCda(numeroCda) {
          this.$refs['extratoCda'].abrirExtrato(numeroCda);
      },
      closeModal() {
          this.$refs['extratoCda'].fecharModais();
      },
      filtrarModelos() {
		  this.modelosPesquisa = [];
		  let possuiFiltroId = (this.filtroIdModelo && this.filtroIdModelo != '');
		  let possuiFiltroDescritivo = (this.filtroDescritivoModelo && this.filtroDescritivoModelo != '');
	      if (possuiFiltroId || possuiFiltroDescritivo) {
		      this.modelos.forEach(el => {
			      if((!possuiFiltroId || parseInt(el.id) == parseInt(this.filtroIdModelo)) &&
				      (!possuiFiltroDescritivo || this.verificarTextoIgual(el.descricao, this.filtroDescritivoModelo))) {
				      this.modelosPesquisa.push(el)
			      }
		      });
	      } else {
		      this.modelosPesquisa = this.modelos;
	      }
          return this.modelosPesquisa;
      }, 
      limparFiltroModelo() {
		  this.filtroIdModelo = '';
		  this.filtroDescritivoModelo = '';
		  this.filtrarModelos();
      },
      verificarTextoIgual(texto, comparativo) {
	      const textoNormalized = texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
	      const comparativoNormalized = comparativo.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();

	      return textoNormalized.includes(comparativoNormalized);
      },
	  onOpenModalPesquisaModelos() {
		  this.modelosPesquisa = this.modelos
      this.listarModelos()
		  this.modeloSelecionado = null
		  this.filtroIdModelo = ''
		  this.filtroDescritivoModelo = ''
	  },
      onOpenModalPesquisaPeticionar() {
		  this.limparMensagemModal()
	      this.tramitacoesEnviadas = []
	      this.enviando = false
	      this.exibirAssinatura = false
	      this.carregarPdfsAssinar()
	  },
      impedirFechar(bvModalEvent) {
	    if(this.enviando) {
		  bvModalEvent.preventDefault()
	    }
      },
	  atribuirModelo(modeloSelecionado) {
		  this.modelo = modeloSelecionado;
	  },
	  listarModelos() {
	    const token = JSON.parse(this.$store.getters.getUser).access_token;
	    axios.get(`${urlApi}/v1/prazos/modelos`, {
		    headers: {
			    'Content-Type': 'application/json',
			    'Authorization': token
		    }
	    }).then((response) => {
			this.modelos = response.data
      this.modelosPesquisa = this.modelos
	    }).catch((error) => {
			this.exibirErro(error)
		})
	  },
      applicarModelo() {
		  let params = {
			  modelo: this.modeloSelecionado.id,
			  prazos: []
		  }

	      this.selecionados.forEach(el => {
		      params.prazos.push(el.codPrazoProcurador)
	      });

	    const token = JSON.parse(this.$store.getters.getUser).access_token;
	    axios.post(`${urlApi}/v1/prazos/vincularModelo`, params, {
		    headers: {
			    'Content-Type': 'application/json',
			    'Authorization': token
		    }
	    }).then((response) => {
			this.modelosApplicados = response.data
		    this.$refs['modalConsultarModelos'].hide()
		    this.$refs['modalSucessoModelos'].show()
		    this.listarAgendaPrazos()
		    this.desselecionarTudo()
	    }).catch((error) => {
			this.exibirErro(error)
		})
	  },
	    classeRelCDAs(relCdas) {
		    if (relCdas == 'TODOS') {
			    return "blue"
		    } else if (relCdas == 'PRINCIPAL') {
			    return "green"
		    } else if (relCdas == 'SEMCDA') {
			    return "red"
		    }
	    },
	    iniciarModalAnexos(item) {
		    this.processoSelecionado = item
		    this.arquivos = []
		    this.arquivosConvertidos = []
	        this.$refs['modalAnexosProcesso'].show()
		    this.limparMensagemModal()
	    },
	    limparMensagemModal() {
		    this.messageModal = {
			    message: null,
			    variant: null
		    }
	    },
	    uploadAnexos() {
		    var arquivosConvertidos = [];
		    var i = 0;
			this.carregarAnexos(arquivosConvertidos, i)
	    },
	    carregarAnexos(arquivosConvertidos, i) {
		    if (i === this.arquivos.length) {
			    this.arquivosConvertidos = arquivosConvertidos
		    } else {
			    var file = this.arquivos[i];
			    var reader = new FileReader();
			    reader.onload = function () {
				    var arquivoFormatado = {
					    nomeArquivo: file.name,
					    base64: reader.result
				    };

				    arquivosConvertidos.push(arquivoFormatado);
			    };
			    reader.readAsDataURL(file);

			    i++;

			    reader.onloadend = () => this.carregarAnexos(arquivosConvertidos, i);
		    }	    
	    },
	    executeUpload() {
		  if(this.arquivosConvertidos.length === this.arquivos.length && !this.uploadIniciado) {
			  this.limparMensagemModal()
			  this.uploadIniciado = true;
			  const token = JSON.parse(this.$store.getters.getUser).access_token;

			  axios.post(`${urlApi}/v1/prazos/adicionarAnexo/${this.processoSelecionado.codPrazoProcurador}`, this.arquivosConvertidos, {
				  headers: {
					  'Content-Type': 'application/json',
					  'Authorization': token
				  }
			  }).then(response => {
				  this.messageModal = { message: 'Anexo adicionado com sucesso!!!', variant: 'success'}
				  this.processoSelecionado.peticionamentoDocumentos = this.processoSelecionado.peticionamentoDocumentos.concat(response.data);
			  }).catch((e) => {
				  this.messageModal = { message: e && e.message ? e.message : e, variant: 'danger'}
			  }).finally(() => {
				  this.arquivos = []
				  this.uploadIniciado = false
			  });
		  }
	    },
	    excluirAnexo(codAnexo) {
		  this.limparMensagemModal()
		  this.uploadIniciado = true;
		  const token = JSON.parse(this.$store.getters.getUser).access_token;

		  axios.delete(`${urlApi}/v1/prazos/removerAnexo/${codAnexo}`, {
			  headers: {
				  'Content-Type': 'application/json',
				  'Authorization': token
			  }
		  }).then(response => {
			  this.messageModal = { message: 'Anexo removido com sucesso!!!', variant: 'success'}
			  let documentos = []
			  for (var anexo of this.processoSelecionado.peticionamentoDocumentos) {
				  if (codAnexo !== anexo.codPeticionamentoDocumento) {
					  documentos.push(anexo);
				  }
			  }
			  this.processoSelecionado.peticionamentoDocumentos = documentos
		  }).catch((e) => {
			  this.messageModal = { message: e && e.message ? e.message : e, variant: 'danger'}
		  }).finally(() => {
			  this.arquivos = []
			  this.uploadIniciado = false
		  });
	    },
	    baixarAnexo(codAnexo, nomeAnexo) {
		    const token = JSON.parse(this.$store.getters.getUser).access_token;

		    axios.get(`${urlApi}/v1/prazos/baixar/anexo/${codAnexo}`, {
			    headers: {
				    'Content-Type': 'application/json',
				    'Authorization': token
			    },
			    responseType: 'arraybuffer'
		    }).then(response => {
			    this.downloadAnexo(response, nomeAnexo);
		    })
	    },
	    listarSelecionadosGerados() {
		    let selecionadosGerados = [];
		    for (var selecionado of this.selecionados) {
			    if (selecionado.statusMinuta.startsWith('Gerada')) {
				    selecionadosGerados.push(selecionado)
			    }
		    }
		    return selecionadosGerados;
	    },
	    listarSelecionadosPrazo() {
		    let selecionadosPrazo = [];
		    for (var selecionado of this.selecionados) {
			    if (selecionado.statusMinuta.startsWith('Gerada')
				    && selecionado.statusPrazo === 'PENDENTE_RESPOSTA') {
				    selecionadosPrazo.push(selecionado)
			    }
		    }
		    return selecionadosPrazo;
	    },
	    excluirMinutas() {
		    const token = JSON.parse(this.$store.getters.getUser).access_token;
			
			let minutas = [];
		    for (var selecionado of this.selecionados) {
			    if (selecionado.statusMinuta.startsWith('Gerada')) {
				    minutas.push(selecionado.codPeticionamento)
			    }
		    }

		    axios.post(`${urlApi}/v1/prazos/limparMinuta`, minutas, {
			    headers: {
				    'Content-Type': 'application/json',
				    'Authorization': token
			    }
		    }).then(response => {
			    this.$refs['modalLimparMinuta'].hide()
			    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Limpeza da minuta realizada com sucesso.'] });
			    window.scrollTo(0, 0);
			    this.listarAgendaPrazos()
			    this.desselecionarTudo()
		    }).catch((error) => {
			    this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
			    window.scrollTo(0, 0);
		    });
	    },
	    alterarRelCda(codPeticionamento, relCda) {
		    const token = JSON.parse(this.$store.getters.getUser).access_token;

		    axios.get(`${urlApi}/v1/prazos/alterarRelCda/${codPeticionamento}/${relCda}`, {
			    headers: {
				    'Content-Type': 'application/json',
				    'Authorization': token
			    }
		    }).catch((error) => {
			    this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
			    window.scrollTo(0, 0);
		    });
	    },
	    iniciarModalMinuta(item) {
		  this.$store.commit("setMessages", {});
		  if (item.enviada) {
			  this.carregarPdfPeticao(item);
		  } else {
			  const token = JSON.parse(this.$store.getters.getUser).access_token;

			  axios.get(`${urlApi}/v1/prazos/minutaEdicao/${item.codPeticionamento}`, {
				  headers: {
					  'Content-Type': 'application/json',
					  'Authorization': token
				  }
			  }).then(response => {
				  this.minutaBloqueio = response.data;
				  item.conteudoMinuta = this.minutaBloqueio.minuta;
				  if (this.minutaBloqueio.bloqueada && !this.minutaBloqueio.possuiAcesso) {
					  this.$store.commit("setMessages", { message: 'Erro!', variant: 'danger',
						  errors: [`Minuta sendo editada por ${this.minutaBloqueio.usuarioAlteracao} (última alteração no arquivo ocorreu no dia ${this.minutaBloqueio.dataAlteracao}).`] });
					  window.scrollTo(0, 0);
				  } else if (this.minutaBloqueio.bloqueada && this.minutaBloqueio.possuiAcesso) {
					  this.processoSelecionado = item
					  this.$refs['modalBloqueioMinuta'].show()
				  } else {
					  this.processoSelecionado = item
					  this.processoSelecionado.statusMinuta = 'Em Edição'
					  this.minutaEditar = item.conteudoMinuta
					  this.$refs['modalEditarMinuta'].show()
				  }
			  }).catch((error) => {
				  this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
				  window.scrollTo(0, 0);
			  });
		  }
	    },
	    bloquearMinuta() {
		    const token = JSON.parse(this.$store.getters.getUser).access_token;

		    axios.get(`${urlApi}/v1/prazos/bloquearMinutaEdicao/${this.processoSelecionado.codPeticionamento}`, {
			    headers: {
				    'Content-Type': 'application/json',
				    'Authorization': token
			    }
		    }).then(response => {
			    this.processoSelecionado.statusMinuta = 'Em Edição'
				this.minutaEditar = this.processoSelecionado.conteudoMinuta
				this.$refs['modalEditarMinuta'].show()
		    }).catch((error) => {
			    this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
			    window.scrollTo(0, 0);
		    }).finally(() => {
			    this.$refs['modalBloqueioMinuta'].hide()
		    });	
	    },
	    alterarMinuta() {
		    const token = JSON.parse(this.$store.getters.getUser).access_token;
			
			let minuta = {
				codPeticionamentoPrazo: this.processoSelecionado.codPeticionamento,
				minuta: this.minutaEditar
		    }

		    axios.post(`${urlApi}/v1/prazos/alterarMinuta`, minuta, {
			    headers: {
				    'Content-Type': 'application/json',
				    'Authorization': token
			    }
		    }).then(response => {
			    let minutaBloqueio = response.data
			    if (minutaBloqueio && minutaBloqueio.bloqueada) {
				    this.minutaBloqueio = minutaBloqueio
				    this.$store.commit("setMessages", { message: 'Erro!', variant: 'danger',
					    errors: [`Minuta sendo editada por ${this.minutaBloqueio.usuarioAlteracao} (última alteração no arquivo ocorreu no dia ${this.minutaBloqueio.dataAlteracao}).`] })
			    } else {
				    this.processoSelecionado.conteudoMinuta = this.minutaEditar
				    this.processoSelecionado.statusMinuta = 'Gerada'
				    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Minuta alterada com sucesso.'] });
			    }
			    this.$refs['modalEditarMinuta'].hide()
			    window.scrollTo(0, 0)
			    setTimeout(() => {
				    this.minutaEditar = null
				    this.processoSelecionado = null
			    }, 1000)
		    }).catch((error) => {
			    this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
			    window.scrollTo(0, 0);
		    });
	    },
	    imprimirMinuta() {
		    const token = JSON.parse(this.$store.getters.getUser).access_token;

		    let minuta = {
			    codPeticionamentoPrazo: this.processoSelecionado.codPeticionamento,
			    minuta: this.minutaEditar
		    }

		    axios.post(`${urlApi}/v1/prazos/minuta/imprimir`, minuta, {
			    headers: {
				    'Content-Type': 'application/json',
				    'Authorization': token
			    },
			    responseType: 'arraybuffer'
		    }).then(response => {
			    this.downloadPDF(response, 'relatorio-minuta.pdf');
		    })
	    },
	    carregarCertificado(){
		    apiCentralSeguranca.getInformacoesCidadao((JSON.parse(this.$store.getters.getUser).access_token))
			    .then(res => {
					this.cpfUsuario = res.data.cpf
				    this.parametrosAssinatura.filters.CPFS.push(this.cpfUsuario)
			    })
	    },
	    carregarPdfsAssinar(){
		    this.limparMensagemModal()
		    this.$refs.loading.showLoading()
		    const token = JSON.parse(this.$store.getters.getUser).access_token;

		    let prazos = [];
		    for (var selecionado of this.selecionados) {
			    if (selecionado.statusMinuta.startsWith('Gerada')
				    && selecionado.statusPrazo === 'PENDENTE_RESPOSTA') {
				    prazos.push(selecionado.codPrazoProcurador)
			    }
		    }

		    axios.post(`${urlApi}/v1/prazos/prepararDocumentosAssinatura`, prazos, {
			    headers: {
				    'Content-Type': 'application/json',
				    'Authorization': token
			    }
		    }).then(response => {
			    this.listaPdfsRetorno = response.data
			    if (!this.listaPdfsRetorno || this.listaPdfsRetorno.length <= 0) {
				    this.messageModal = { message: 'Nenhum documento encontrado para assinatura.', variant: 'warning'}
				    this.enviando = false
				    this.exibirAssinatura = false
			    } else {
				    this.parametrosAssinatura.arquivo = this.listaPdfsRetorno
				    this.exibirAssinatura = true
			    }
		    }).catch((e) => {
			    this.messageModal = { message: e && e.message ? e.message : e, variant: 'danger'}
			    this.enviando = false
			    this.exibirAssinatura = false
		    }).finally(() => {
			    this.$refs.loading.hideLoading()
		    });
	    },
	    processarErroAssinatura(erro){
		    this.messageModal = { message: erro, variant: 'danger'}
	    },
	    processarArquivoAssinado(arquivosAssinadosB64){
		    if (this.enviando) {
				return
		    }

		    this.enviando = true

		    this.limparMensagemModal()
		    const token = JSON.parse(this.$store.getters.getUser).access_token;

		    for (var arquivo of arquivosAssinadosB64) {
			    for (var arquivoOriginal of this.listaPdfsRetorno) {
				    if (arquivoOriginal.name === arquivo.nomeArquivoAssinado) {
					    arquivoOriginal.nomeArquivoAssinado = arquivo.nomeArquivoAssinado
					    arquivoOriginal.arquivoAssinadoBase64 = arquivo.arquivoAssinadoBase64
					    break
				    }
			    }
		    }

		    axios.post(`${urlApi}/v1/prazos/finalizarPeticionar`, this.listaPdfsRetorno, {
			    headers: {
				    'Content-Type': 'application/json',
				    'Authorization': token
			    }
		    }).then(response => {
				this.tramitacoesEnviadas = response.data
			    let mensagemErro = ''
				
				for (var tramitacao of this.tramitacoesEnviadas) {
					if (!tramitacao.sucesso) {
						if (mensagemErro === '') {
							mensagemErro = 'Ressincronize a sua agenda de prazos! '
						} else {
							mensagemErro += '\n'
						}
						mensagemErro += `${tramitacao.mensagem}`
					}
				}
				
				if (mensagemErro === '') {
					this.messageModal = { message: 'Tramitação realizada com sucesso.', variant: 'success'}
				} else {
					this.messageModal = { message: mensagemErro, variant: 'danger'}
				}

			    this.listarAgendaPrazos()
			    this.desselecionarTudo()
		    }).catch((e) => {
			    this.messageModal = { message: e && e.message ? e.message : e, variant: 'danger'}
		    }).finally(() => {
			    this.enviando = false
		    });
	    },
	    protocoloEnvio(cnj){
		    for (var tramitacao of this.tramitacoesEnviadas) {
			    if (tramitacao.cnj === cnj) {
					return ` (prot. ${tramitacao.protocolo}, ${tramitacao.data})`
			    }
		    }
			return ''
	    },
	    carregarPdfPeticao(item) {
		    this.pdfPeticao = null
		    const token = JSON.parse(this.$store.getters.getUser).access_token;

		    axios.get(`${urlApi}/v1/prazos/peticao/${item.codPeticionamento}`, {
			    headers: {
				    'Content-Type': 'application/json',
				    'Authorization': token
			    }
		    }).then( (response) => {
			    this.processoSelecionado = item
			    this.pdfPeticao = 'data:application/pdf;base64,' + response.data
			    this.$refs['modalVisualizarPeticao'].show()
		    }).catch((error) => {
			    this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
			    window.scrollTo(0, 0);
		    })
	    },
	    verificarPermissaoUsuario() {
		    let userData = JSON.parse(this.$store.getters.getUser);
		    if (userData.groups) {
			    this.apenasGrupoAsses = true
			    let gruposPermitidos = ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-AGENDAPRAZO-PROC'];
			    for (let i = 0; i < userData.groups.length; i++) {
				    let grupoUsuario = userData.groups[i];

				    if (gruposPermitidos.indexOf(grupoUsuario) != -1) {
					    this.apenasGrupoAsses = false;
					    break;
				    }
			    }
		    }
	    }
    }
  };
  
  </script>
  
  <style lang="scss">
  .breadcrumb {
    margin-bottom: 0 !important;
  }
  .cell-warning {
    background-color: #EFEF71 ;
  }
  .cell-danger {
    background-color: #FFC8CE ;
  }
  .table-prazo {
    text-align: center;
  }
  .header-modal-ver-movimento {
    border-bottom: 0 !important;
    padding-bottom: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .celula-cnj{
    padding: 1 !important;
    width: 320px !important;
  }
  .celula-selecao{
    padding: 1 !important;
    width: 20px !important;
  }
  .table-C6E2FF{
      background: #C6E2FF;
  }
  .table-6495ED{
      background: #6495ED;
  }
  .table-87CEEB{
      background: #87CEEB;
  }
  .table-ADD8E6{
      background: #ADD8E6;
  }
  .table-B0C4DE{
      background: #B0C4DE;
  }
  .table-7FFFD4{
      background: #7FFFD4;
  }
  .table-90EE90{
      background: #90EE90;
  }
  .table-DAA520{
      background: #DAA520;
  }
  .table-B8860B{
      background: #B8860B;
  }
  .table-BC8F8F{
      background: #BC8F8F;
  }
  .table-FFDEAD{
      background: #FFDEAD;
  }
  .table-F5DEB3{
      background: #F5DEB3;
  }
  .table-DEB887{
      background: #DEB887;
  }
  .table-D2B48C{
      background: #D2B48C;
  }
  .table-FF00FF{
      background: #FF00FF;
  }
  .table-EE82EE{
      background: #EE82EE;
  }
  .table-DA70D6{
      background: #DA70D6;
  }
  .table-DDA0DD{
      background: #DDA0DD;
  }
  .table-FFC0CB{
      background: #FFC0CB;
  }
  .table-FFD700{
      background: #FFD700;
  }
  .table-ADD8E6{
      background: #ADD8E6;
  }
  .table-E6E6FA{
      background: #E6E6FA;
  }
  .table-FFE4E1{
      background: #FFE4E1;
  }
  .table-F0E68C{
      background: #F0E68C;
  }
  .table-D8BFD8{
      background: #D8BFD8;
  }
  .table-B0E0E6{
      background: #B0E0E6;
  }
  .table-AFEEEE{
      background: #AFEEEE;
  }
  .table-F5F5DC{
      background: #F5F5DC;
  }
  .table-FFFACD{
      background: #FFFACD;
  }
  .table-E0FFFF{
      background: #E0FFFF;
  }
  .table-F0FFF0{
      background: #F0FFF0;
  }
  .table-E1F7D5{
      background: #E1F7D5;
  }
  .table-FFBDBD{
      background: #FFBDBD;
  }
  .table-C9C9FF{
      background: #C9C9FF;
  }
  .table-F1CBFF{
      background: #F1CBFF;
  }
  .table-D3D3D3{
      background: #D3D3D3;
  }
  .table-D1F7C4{
      background: #D1F7C4;
  }
  .table-FDE4CF{
      background: #FDE4CF;
  }
  .table-FFF9C4{
      background: #FFF9C4;
  }
  .table-FFECB3{
      background: #FFECB3;
  }
  .table-E1F5FE{
      background: #E1F5FE;
  }
  .table-F8BBD0{
      background: #F8BBD0;
  }
  .table-DCEDC8{
      background: #DCEDC8;
  }
  .table-FFCDD2{
    background: #FFCDD2;
  }
  .table-EFEF71{
    background: #EFEF71;
  }
  .table-FFC8CE{
    background: #FFC8CE;
  }
  .negrito {
    font-weight: bold;
    font-size: 0.87rem;
  }
  i::before{
    background:transparent;
  }
  .iconeTransparente {
    background:transparent;
    border: transparent;
  }
  .vue-pdf-embed > div {
    margin-bottom: 8px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
  }
  .tdDataAju:has(.data-aju-fce5cd) {
    background: #fce5cd;
  }
  .tdDataAju:has(.data-aju-f4cccc) {
    background: #f4cccc;
  }
  .tdDataAju:has(.data-aju-e06666) {
    background: #e06666;
  }
  .mw-60 {
    min-width: 60px;
  }
  .mw-100 {
    min-width: 100px;
  }
  .mw-120 {
    min-width: 120px;
  }
  th {
    text-align: center !important;
  }
  .sticky-block {
    position: sticky !important;
    top: 60px;
    z-index: 2;
  }

  .bg-primary {
    background-color: #0073c0 !important;
  }

  .modal-dialog.modal-lg {
	  max-height: 70%;
  }

  .modal-dialog.modal-lg .modal-content {
	  height: 100%;
  }
  .modal-dialog.modal-lg .modal-content .modal-body {
	  overflow: auto;
	  height: 100%;
  }

  .overflow-grid {
	max-height: 430px;
	overflow: auto;
  }
  
  .btn-link-vazio {
	color: #73818f !important;
  }

  .btn-link-vazio .fa-15x:hover {
	  color: #23282c !important;
	  background-color: #c8ced3;
	  border-color: #c8ced3;
  }

  .div-btn-limpar-minuta {
	  height: 100px;
	  position: relative;
  }

  .div-btn-limpar-minuta div {
	  margin: 0;
	  position: absolute;
	  top: 50%;
	  left: 50%;
	  -ms-transform: translate(-50%, -50%);
	  transform: translate(-50%, -50%);
  }

  .div-btn-limpar-minuta div button {
	  width: 100%;
  }
  
  .certificado div div div.row div div div form div div {
	  flex: 0 0 100% !important;
	  max-width: 100% !important;
  }

  .vld-overlay.is-full-page {
	  z-index: 1100;
  }

  .btn-secondary.fonte-branca:disabled {
	  color: unset !important;
	  cursor: not-allowed;
  }
  
  .close.text-white:disabled {
	  cursor: not-allowed;
  }

  </style>
  
